<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash"  @exps="expjqdialog" @imp="impt" @save="save(0)"
                    @del="del" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[945]')" id="xpane-0" name="0">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="getISS" :disabled="!btn.ISS">{{$t('getapi[6761]')}}</el-button>
                            <el-button type="primary" size="mini" @click="getPro" :disabled="!btn.Pro">{{$t('getapi[7045]')}}</el-button>
                            <el-button type="primary" size="mini" @click="soInQty">{{$t('getapi[7053]')}}</el-button>
                            <el-button type="primary" size="mini" @click="getSpotcheckFlag">{{$t('getapi[12612]')}}</el-button>
                            <el-button type="primary" size="mini" @click="batchDuty" :disabled="!btn.duty">{{$t('getapi[12922]')}}</el-button>
                        </div>
                        <vTable
                                :data="dataSet"
                                ref="singleTable"
                                :loading="loading"
                                queryData="ProSoMasterViewInfo"
                                :filter_language="['SO_Status','Force_Close_Flag','Bom_Config_Flag','new_flag','Direct_Stuff_Move_flag','ce_flag','pause_flag']"
                                :filter_thousandth="['Plan_Finish_qty','Actual_Finish_Qty','Finished_Product_Receive','Produce_LeadTime','To_inv_qty','scrap_qty']"
                                :filter_date="['Plan_Finish_date']"
                                :header="tableHeader"
                                :height="tableHeight - reduceTableHeight"
                                @handleSelectionChange="handleSelectionChange"
                                @handleSelectionChangeAll="handleSelectionChangeAll"
                                @handleSelectionChangeEnd="handleSelectionChange"
                                @edits="edits"
                                @lct="lct"
                                @rowdblclick="openEdit"
                        ></vTable>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1422]')" id="xpane-1" name="1">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="batchRelease" :disabled="!btn.batchRelease">
                                {{$t('getapi[3056]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="getISS" :disabled="!btn.ISS">{{$t('getapi[6761]')}}</el-button>
                            <el-button type="primary" size="mini" @click="getPro" :disabled="!btn.Pro">{{$t('getapi[7045]')}}</el-button>
                            <el-button type="primary" size="mini" @click="itemPlanAudit(1)" :disabled="selectData1.length < 1">{{$t('getapi[9855]')}}</el-button>
                        </div>
                        <vTable
                                :data="dataSet1"
                                ref="singleTable1"
                                :loading="loading"
                                queryData="ProSoMasterViewInfo"
                                :filter_language="['SO_Status','Force_Close_Flag','Bom_Config_Flag','new_flag','Direct_Stuff_Move_flag','ce_flag','pause_flag']"
                                :filter_thousandth="['Plan_Finish_qty','Actual_Finish_Qty','Finished_Product_Receive','Produce_LeadTime','To_inv_qty','scrap_qty']"
                                :filter_date="['Plan_Finish_date']"
                                :header="tableHeader"
                                :height="tableHeight - reduceTableHeight"
                                @handleSelectionChange="handleSelectionChange1"
                                @handleSelectionChangeAll="handleSelectionChangeAll1"
                                @handleSelectionChangeEnd="handleSelectionChange1"
                                @edits="edits"
                                @lct="lct"
                                @rowdblclick="openEdit"
                        ></vTable>
                        
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6095]')" id="xpane-2" name="2">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="getMPSBillInfo"
                                       :disabled="!btn.listProReport">{{$t('getapi[4479]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="getISS" :disabled="!btn.ISS">{{$t('getapi[6761]')}}</el-button>
                            <el-button type="primary" size="mini" @click="getPro" :disabled="!btn.Pro">{{$t('getapi[7045]')}}</el-button>
                            <el-button type="primary" size="mini" @click="suspend" v-if="isSuspend==1"
                                       :disabled="!btn.suspend">{{$t('getapi[7054]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="recover" v-if="isSuspend==2"
                                       :disabled="!btn.recover">{{$t('getapi[3874]')}}
                            </el-button>
                        </div>
                        <vTable
                                :data="dataSet2"
                                ref="singleTable2"
                                :loading="loading"
                                queryData="ProSoMasterViewInfo"
                                :filter_language="['SO_Status','Force_Close_Flag','Bom_Config_Flag','new_flag','Direct_Stuff_Move_flag','ce_flag','pause_flag']"
                                :filter_thousandth="['Plan_Finish_qty','Actual_Finish_Qty','Finished_Product_Receive','Produce_LeadTime','To_inv_qty','scrap_qty']"
                                :filter_date="['Plan_Finish_date']"
                                :header="tableHeader"
                                :height="tableHeight - reduceTableHeight"
                                @handleSelectionChange="handleSelectionChange2"
                                @handleSelectionChangeAll="handleSelectionChangeAll2"
                                @handleSelectionChangeEnd="handleSelectionChange2"
                                @edits="edits"
                                @lct="lct"
                                @rowdblclick="openEdit"
                        ></vTable>
                        
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[3073]')" id="xpane-3" name="3">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="getISS" :disabled="!btn.ISS">{{$t('getapi[6761]')}}</el-button>
                            <el-button type="primary" size="mini" @click="getPro" :disabled="!btn.Pro">{{$t('getapi[7045]')}}</el-button>
                            <el-button type="primary" size="mini" @click="getMPSBillInfo"
                                       :disabled="!btn.listProReport">{{$t('getapi[4479]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="suspend" v-if="isSuspend==1"
                                       :disabled="!btn.suspend">{{$t('getapi[7054]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="recover" v-if="isSuspend==2"
                                       :disabled="!btn.recover">{{$t('getapi[3874]')}}
                            </el-button>
                        </div>
                        <vTable
                                :data="dataSet3"
                                ref="singleTable3"
                                :loading="loading"
                                queryData="ProSoMasterViewInfo"
                                :filter_language="['SO_Status','Force_Close_Flag','Bom_Config_Flag','new_flag','Direct_Stuff_Move_flag','ce_flag','pause_flag']"
                                :filter_thousandth="['Plan_Finish_qty','Actual_Finish_Qty','Finished_Product_Receive','Produce_LeadTime','To_inv_qty','scrap_qty']"
                                :filter_date="['Plan_Finish_date']"
                                :header="tableHeader"
                                :height="tableHeight - reduceTableHeight"
                                @handleSelectionChange="handleSelectionChange3"
                                @handleSelectionChangeAll="handleSelectionChangeAll3"
                                @handleSelectionChangeEnd="handleSelectionChange3"
                                @edits="edits"
                                @lct="lct"
                                @rowdblclick="openEdit"
                        ></vTable>
                        
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6097]')" id="xpane-4" name="4">
                        <vTable
                                :data="dataSet4"
                                ref="singleTable4"
                                :loading="loading"
                                queryData="ProSoMasterViewInfo"
                                :filter_language="['SO_Status','Force_Close_Flag','Bom_Config_Flag','new_flag','Direct_Stuff_Move_flag','ce_flag','pause_flag']"
                                :filter_thousandth="['Plan_Finish_qty','Actual_Finish_Qty','Finished_Product_Receive','Produce_LeadTime','To_inv_qty','scrap_qty']"
                                :filter_date="['Plan_Finish_date']"
                                :header="tableHeader"
                                :height="tableHeight - reduceTableHeight"
                                @handleSelectionChange="handleSelectionChange4"
                                @handleSelectionChangeAll="handleSelectionChangeAll4"
                                @handleSelectionChangeEnd="handleSelectionChange4"
                                @edits="edits"
                                @lct="lct"
                                @rowdblclick="openEdit"
                        ></vTable>
                        
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6096]')" id="xpane-5" name="5">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="getISS" :disabled="!btn.ISS">{{$t('getapi[6761]')}}</el-button>
                            <el-button type="primary" size="mini" @click="getPro" :disabled="!btn.Pro">{{$t('getapi[7045]')}}</el-button>
                        </div>
                        <vTable
                                :data="dataSet5"
                                ref="singleTable5"
                                :loading="loading"
                                queryData="ProSoMasterViewInfo"
                                :filter_language="['SO_Status','Force_Close_Flag','Bom_Config_Flag','new_flag','Direct_Stuff_Move_flag','ce_flag','pause_flag']"
                                :filter_thousandth="['Plan_Finish_qty','Actual_Finish_Qty','Finished_Product_Receive','Produce_LeadTime','To_inv_qty','scrap_qty']"
                                :filter_date="['Plan_Finish_date']"
                                :header="tableHeader"
                                :height="tableHeight - reduceTableHeight"
                                @handleSelectionChange="handleSelectionChange5"
                                @handleSelectionChangeAll="handleSelectionChangeAll5"
                                @handleSelectionChangeEnd="handleSelectionChange5"
                                @edits="edits"
                                @lct="lct"
                                @rowdblclick="openEdit"
                        ></vTable>
                        
                    </el-tab-pane>
                    <!--<el-tab-pane :label="$t('getapi[12611]')" id="xpane-6" name="6">
                        <wTable
                                :data="dataSet6"
                                ref="singleTable6"
                                :loading="loading"
                                queryData="ProSoMasterViewInfo"
                                :filter_language="['SO_Status','Force_Close_Flag','Bom_Config_Flag','new_flag','Direct_Stuff_Move_flag','ce_flag']"
                                :filter_thousandth="['Plan_Finish_qty','Actual_Finish_Qty','Finished_Product_Receive','Produce_LeadTime','To_inv_qty','scrap_qty']"
                                :header="tableHeader"
                                :option="tableOption1"
                                @handleSelectionChange="handleSelectionChange6"
                                @edits="edits"
                                @lct="lct"
                                @rowdblclick="openEdit"
                        ></wTable>

                    </el-tab-pane>-->
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div class="btnnowrap">
                        <el-button type="primary" size="mini" @click="billRelease" :disabled="!btn.billRelease">{{
                            $t('getapi[3085]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="soBillCancel" :disabled="!btn.soBillCancel">{{
                            $t('getapi[3086]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="billClose" :disabled="!btn.billClose">{{
                            $t('getapi[3557]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="changeRoutVer" :disabled="!btn.changeRoutVer">
                            {{$t('getapi[7055]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click="itemPlanAudit(2)" :disabled="dataDetail.Head.so_status != 0">{{$t('getapi[9855]')}}</el-button>
                    </div>
                    <div style="width:1330px;min-width:1330px">
                        <table>
                        <tr>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[4168]') }}</td>
                            <td style="width:200px;min-width:200px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.so_code"
                                          :readonly="addoredit != 0" :class="{'readO':addoredit != 0}"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[112]') }}</td>
                            <td style="width:180px;min-width:180px">
                                <routejump :urlNo="12" v-if="addoredit == 0">
                                <el-input type="text" v-model="dataDetail.Head.part_code" readonly class="mcolor"
                                          size="mini" >
                                    <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectpart()"></i>
                                </el-input>

                                </routejump>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.part_code" :readonly="true" class="readO"
                                          v-if="addoredit != 0"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[149]') }}</td>
                            <td style="width:50px;min-width:50px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.part_version"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:30px;min-width:30px">{{ $t('getapi[547]') }}</td>
                            <td style="width:50px;min-width:50px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.routing_version"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:100px;min-width:100px">
                                <el-checkbox v-model="dataDetail.Head.force_close_flag" true-label="1" false-label="0"
                                             :disabled="true"></el-checkbox>
                                {{ $t('getapi[2345]') }}
                            </td>
                            <td style="width:50px;min-width:50px">{{ $t('getapi[552]') }}</td>
                            <td style="width:120px;min-width:120px">
                                <el-input type="text" size="mini" :value="expStatus(dataDetail.Head.so_status)"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:100px;min-width:100px">
                                <el-checkbox v-model="dataDetail.Head.need_schedule" true-label="1" false-label="0"
                                             :disabled="true"></el-checkbox>
                                {{ $t('getapi[7056]') }}
                            </td>
                            <td style="width:50px;min-width:50px">{{ $t('getapi[133]') }}</td>
                            <td style="width:200px;min-width:200px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.page_no" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[4209]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.schedule_no"
                                          :readonly="dataDetail.Head.so_status != 0" :class="{'readO':dataDetail.Head.so_status != 0}"></el-input>
                            </td>
                            <td>{{ $t('getapi[4213]') }}</td>
                            <td>
                                <el-input
                                        type="number"
                                        autocomplete="off" title=""
                                        @mousewheel.native.prevent
                                        size="mini"
                                        v-model="dataDetail.Head.plan_finish_qty"
                                        v-if="dataDetail.Head.so_status == 0"
                                        class="mcolor"
                                        @blur="getSoStuffQty(dataDetail.Head.plan_finish_qty)"
                                        @focus="$refs.SetBtn.SetOneBtnEnable('save', false)"
                                ></el-input>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.plan_finish_qty"
                                          v-if="dataDetail.Head.so_status != 0" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[4217]') }}</td>
                            <td colspan="3">
                                <el-select @change="selectChanaged" filterable v-model="dataDetail.Head.so_type"
                                           size="mini" :disabled="dataDetail.Head.so_status == 3">
                                    <el-option key="0" :label="$t('getapi[2406]')" value="0" :disabled="dataDetail.Head.so_status != 0 && (dataDetail.Head.so_type ==1 || dataDetail.Head.so_type ==3)"></el-option>
                                    <el-option key="1" :label="$t('getapi[7051]')" value="1" :disabled="dataDetail.Head.so_status != 0 && (dataDetail.Head.so_type ==0 || dataDetail.Head.so_type ==2)"></el-option>
                                    <el-option key="2" :label="$t('getapi[7052]')" value="2" :disabled="dataDetail.Head.so_status != 0 && (dataDetail.Head.so_type ==1 || dataDetail.Head.so_type ==3)"></el-option>
                                    <el-option key="3" :label="$t('getapi[8199]')" value="3" :disabled="dataDetail.Head.so_status != 0 && (dataDetail.Head.so_type ==0 || dataDetail.Head.so_type ==2)"></el-option>
                                </el-select>
                            </td>
                            <td>
                                <el-checkbox v-model="dataDetail.Head.new_flag" true-label="1" false-label="0"
                                             :disabled="dataDetail.Head.so_status != 0"></el-checkbox>
                                {{ $t('getapi[3069]') }}
                            </td>
                            <td>{{ $t('getapi[3437]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.item_code"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td>
                                <el-checkbox v-model="dataDetail.Head.already_schedule" true-label="1" false-label="0"
                                             :disabled="true"></el-checkbox>
                                {{ $t('getapi[7057]') }}
                            </td>
                            <td style="width:50px">{{ $t('getapi[8388]') }}</td>
                            <td style="width:200px;">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.routing_road"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[4215]') }}</td>
                            <td>
                                <el-date-picker
                                        v-model="dataDetail.Head.plan_finish_date"
                                        clear-icon
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        size="mini"
                                        style="width:100%"
                                        v-if="dataDetail.Head.so_status == 0 || dataDetail.Head.so_status == 1 || dataDetail.Head.so_status == 2"
                                        class="mcolor"
                                ></el-date-picker>
                                <el-date-picker
                                        v-model="dataDetail.Head.plan_finish_date"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        size="mini"
                                        style="width:100%"
                                        v-if="dataDetail.Head.so_status != 0 && dataDetail.Head.so_status != 1 && dataDetail.Head.so_status != 2"
                                        :readonly="true" class="readO"
                                ></el-date-picker>
                            </td>
                            <td></td>
                            <td>
                                <el-checkbox
                                        v-model="dataDetail.Head.direct_stuff_move_flag"
                                        true-label="1"
                                        false-label="0"
                                        :disabled="dataDetail.Head.so_status != 0 && dataDetail.Head.so_status != 1 && dataDetail.Head.so_status != 2"
                                        @change="clearMoveDirection"
                                ></el-checkbox>
                                {{ $t('getapi[553]') }}
                            </td>
                            <td>{{ $t('getapi[554]') }}</td>
                            <td colspan="3">
                                <el-select filterable v-model="dataDetail.Head.move_direction" size="mini"
                                           :disabled="dataDetail.Head.direct_stuff_move_flag != 1">
                                    <el-option v-for="item in moveDirectionArr" :key="item.Code" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                            </td>
                            <td>
                                <el-checkbox v-model="dataDetail.Head.manual_plan" true-label="1" false-label="0"
                                             :disabled="!btn.manual_plan"></el-checkbox>
                                {{ $t('getapi[4256]') }}
                            </td>
                            <td>{{ $t('getapi[1850]') }}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.finished_product_receive"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td>
                                <el-checkbox
                                        v-model="dataDetail.Head.lock_schedule"
                                        true-label="1"
                                        false-label="0"
                                        :disabled="dataDetail.Head.so_status != 1 && dataDetail.Head.so_status != 2"
                                ></el-checkbox>
                                {{ $t('getapi[7058]') }}
                            </td>
                            <td style="width:50px">{{ $t('getapi[12391]') }}</td>
                            <td style="width:200px;">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.routing_remark"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <el-checkbox v-model="dataDetail.Head.bom_config_flag" true-label="1" false-label="0"
                                             :disabled="true"></el-checkbox>
                                {{ $t('getapi[123]') }}
                            </td>
                            <td>{{ $t('getapi[3662]') }}</td>
                            <td>
                                <el-select filterable v-model="dataDetail.Head.bom_config_sign" size="mini"
                                           :disabled="dataDetail.Head.bom_config_flag != 1">
                                    <el-option v-for="item in SignList" :key="item.config_sign"
                                               :label="item.config_sign" :value="item.config_sign"></el-option>
                                </el-select>
                            </td>
                            <td colspan="4">
                                <!--<el-checkbox v-model="dataDetail.Head.iss_self_bad_flag" true-label="1" false-label="0"
                                             :disabled="iss_self_bad_flag"></el-checkbox>
                                {{ $t('getapi[4254]') }}-->
                            </td>
                            <td>
                                <el-checkbox v-model="dataDetail.Head.pause_flag" true-label="1" false-label="0"
                                             :disabled="true"></el-checkbox>
                                {{ $t('getapi[7054]') }}
                            </td>
                            <td>{{ $t('getapi[4255]') }}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.bad_qty"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td colspan="2">
                                <el-checkbox
                                        v-model="dataDetail.Head.iss_venderreason_flag"
                                        true-label="1"
                                        false-label="0"
                                        :disabled="dataDetail.Head.so_status != 0 || dataDetail.Head.so_type != 1"
                                ></el-checkbox>
                                {{ $t('getapi[6768]') }}
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[2168]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.print_batch_no"></el-input>
                            </td>
                            <td>{{ $t('getapi[8509]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.mrb_no"></el-input>
                            </td>
                            <td>{{ $t('getapi[8432]') }}</td>
                            <td colspan="3">
                                <el-date-picker v-model="dataDetail.Head.cancel_time" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                    </table>
                    </div>
                    <div class="btnnowrap" style="position: relative;margin-left: 10rem; min-height: 16px;z-index:1000">
                        <el-button v-if="showbtn == 0" type="primary" size="mini" @click="selectworkcenter('')"
                                   :disabled="dataDetail.Head.so_status != 0 && dataDetail.Head.so_status != 1 && dataDetail.Head.so_status != 2 || btn.gyzl">
                            {{ $t('getapi[4257]') }}
                        </el-button>
                        <el-button
                                type="primary"
                                v-if="showbtn == 2"
                                size="mini"
                                @click="selectpartassist('')"
                                :disabled="(dataDetail.Head.so_status != 0 && dataDetail.Head.so_status != 1 && dataDetail.Head.so_status != 2)||dataDetail.Head.allow_assist_add != 0"
                        >
                            {{ $t('getapi[878]') }}
                        </el-button>
                        <el-button v-if="showbtn == 2" type="primary" size="mini" @click="batchReplacePart"
                                   :disabled="!btn.batchReplacePart">{{ $t('getapi[7059]') }}
                        </el-button>
                        <el-button v-if="showbtn == 2" type="primary" size="mini" @click="updateLLC" :disabled="!btn.updateLLC">{{ $t('getapi[12713]') }}

                        </el-button>
                    </div>
                    <el-tabs :tab-position="'top'" type="" style="margin-top: -20px" @tab-click="handleClick">
                        <el-tab-pane :label="$t('getapi[4257]')" id="xdetilpane-0" name="0">
                            <el-table
                                    :data="dataDetail.Lists"
                                    :loading="loadingDetail"
                                    @selection-change="handleSelectionChangeDetail"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 188"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:5px"
                                    :header-cell-style="$limits.headerClass"
                            >
                                <el-table-column type="selection" v-if="false"></el-table-column>
                                <el-table-column prop="routing_sequence_no" :label="$t('getapi[573]')" align="right" width="50">
                                    <template scope="scope">
                                        <template v-if="(dataDetail.Head.so_status == 0) ||  scope.row.exclusively_id<=0">
                                            <el-input
                                                    size="mini"
                                                    type="number"
                                                    autocomplete="off" title=""
                                                    @mousewheel.native.prevent
                                                    v-model="scope.row.routing_sequence_no"
                                                    class="mcolor"
                                                    style="width: 50px;"
                                                    @change="checkrouting_sequence_no(scope)"
                                            ></el-input>
                                        </template>
                                        <template v-else>
                                            <el-input
                                                    size="mini"
                                                    type="number"
                                                    autocomplete="off" title=""
                                                    @mousewheel.native.prevent
                                                    v-model="scope.row.routing_sequence_no"
                                                    readonly
                                            ></el-input>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="workcenter_code" :label="$t('getapi[584]')" width="100">
                                    <template scope="scope" >
                                        <template v-if="dataDetail.Head.so_status == 0 || scope.row.exclusively_id<=0">
                                            <el-input v-model="scope.row.workcenter_code" type="text" readonly
                                                    class="mcolor" size="mini">
                                                <i class="el-icon-edit el-input__icon" slot="suffix"
                                                @click="selectworkcenter(scope)"></i>
                                            </el-input>
                                        </template>
                                        <template v-else>
                                            <el-input
                                                    size="mini"
                                                    type="text"
                                                    v-model="scope.row.workcenter_code"
                                                    readonly
                                            ></el-input>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="workcenter_name"
                                                 :label="$t('getapi[882]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="cd_code"
                                                 :label="$t('getapi[3314]')"></el-table-column>
                                <el-table-column prop="workproc_name" :label="$t('getapi[574]')"
                                                 width="120">
                                    <template scope="scope">
                                        <template v-if="dataDetail.Head.so_status == 0 || scope.row.exclusively_id<=0">
                                            <el-input v-model="scope.row.workproc_name" type="text" readonly class="mcolor"
                                                    size="mini">
                                                <i class="el-icon-edit el-input__icon" slot="suffix"
                                                @click="selectroute(scope)"></i>
                                            </el-input>
                                        </template>
                                        <template v-else>
                                            <el-input
                                                    size="mini"
                                                    type="text"
                                                    v-model="scope.row.workproc_name"
                                                    readonly
                                            ></el-input>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="routing_desc" :label="$t('getapi[575]')">
                                    <template scope="scope" >
                                        <template v-if="dataDetail.Head.so_status == 0 || scope.row.exclusively_id<=0">
                                            <el-input v-model="scope.row.routing_desc" type="text" size="mini" @change="ChargeRouting(scope)"></el-input>
                                        </template>
                                        <template v-else>
                                            <el-input
                                                    size="mini"
                                                    type="text"
                                                    v-model="scope.row.routing_desc"
                                                    readonly
                                            ></el-input>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="ready_manhour" :label="$t('getapi[577]')"
                                                 align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="running_manhour" :label="$t('getapi[578]')"
                                                 align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="queue_manhour" :label="$t('getapi[579]')"
                                                 align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="man_power" :label="$t('getapi[586]')"
                                                 align="right"></el-table-column>
                                <el-table-column prop="seq_flag" :label="$t('getapi[12859]')">
                                    <template slot-scope="scope">
                                        <el-checkbox v-model="scope.row.seq_flag" :true-label="1" :false-label="0" :disabled="dataDetail.Head.so_status != 0"></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="start_produce_time"
                                                 :label="$t('getapi[4260]')">
                                    <template scope="scope">
                                        <!--<el-date-picker
											v-model="scope.row.start_produce_time"
											type="date"
											size="mini"
											style="width:100%"
											v-if="dataDetail.Head.manual_plan == 1"
										></el-date-picker>-->
                                        <el-input v-model="scope.row.start_produce_time"
                                                  v-if="dataDetail.Head.manual_plan == 1"></el-input>
                                        <span v-if="dataDetail.Head.manual_plan != 1">{{ scope.row.start_produce_time }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="finish_produce_time"
                                                 :label="$t('getapi[4261]')">
                                    <template scope="scope">
                                        <!--<el-date-picker
											v-model="scope.row.finish_produce_time"
											type="date"
											size="mini"
											style="width:100%"
											v-if="dataDetail.Head.manual_plan == 1"
										></el-date-picker>-->
                                        <el-input v-model="scope.row.finish_produce_time"
                                                  v-if="dataDetail.Head.manual_plan == 1"></el-input>
                                        <span v-if="dataDetail.Head.manual_plan != 1">{{ scope.row.finish_produce_time }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="modify_person"
                                                 :label="$t('getapi[733]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="modify_time"
                                                 :label="$t('getapi[1210]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="finish_qty"
                                                 :label="$t('getapi[4262]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="report_s_date"
                                                 :label="$t('getapi[7060]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="report_s_person"
                                                 :label="$t('getapi[7061]')"></el-table-column>
                                <el-table-column prop="s_flag_name" :label="$t('getapi[7062]')">
                                    <template scope="scope">
                                        <span>{{ scope.row.s_flag_name | lanchange}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="exception_flag_name"
                                                 :label="$t('getapi[3949]')">
                                    <template scope="scope">
                                        <span>{{ scope.row.exception_flag_name | lanchange}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="pos_qty" :label="$t('getapi[6811]')"
                                                 align="right"></el-table-column>
                                <el-table-column prop="check_status" :label="$t('getapi[7063]')">
                                    <template scope="scope">
                                        {{ expCStatus(scope.row.check_status,scope.row.finish_qty) }}
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="qualify_qty" :label="$t('getapi[7064]')"
                                                 align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="scrap_qty" :label="$t('getapi[7065]')"
                                                 align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="review_qty_sum" :label="$t('getapi[7066]')"
                                                 align="right"></el-table-column>
                                <el-table-column prop="key_flag" :label="$t('getapi[588]')">
                                    <template scope="scope">
                                        <el-checkbox v-model="scope.row.key_flag" :true-label="1" :false-label="0"
                                                     :disabled="dataDetail.Head.so_status != 0" @change="ChargeRouting(scope)"></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="ready_material_time" :label="$t('getapi[7067]')">
                                    <template scope="scope" >
                                        <template v-if="dataDetail.Head.so_status == 0 || scope.row.exclusively_id<=0">
                                            <el-input v-model="scope.row.ready_material_time" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                    size="mini" @change="ChargeRouting(scope)"></el-input>
                                        </template>
                                        <template v-else>
                                            <el-input
                                                    size="mini"
                                                    type="number"
                                                    autocomplete="off" title=""
                                                    @mousewheel.native.prevent
                                                    v-model="scope.row.ready_material_time"
                                                    readonly
                                            ></el-input>
                                        </template>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="wait_time" :label="$t('getapi[7068]')">
                                    <template scope="scope" >
                                        <template v-if="dataDetail.Head.so_status == 0 || scope.row.exclusively_id<=0">
                                            <el-input v-model="scope.row.wait_time" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" @change="ChargeRouting(scope)"></el-input>
                                        </template>
                                        <template v-else>
                                            <el-input
                                                    size="mini"
                                                    type="number"
                                                    autocomplete="off" title=""
                                                    @mousewheel.native.prevent
                                                    v-model="scope.row.wait_time"
                                                    readonly
                                            ></el-input>
                                        </template>
                                    </template>                                    
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="start_time"
                                                 :label="$t('getapi[7069]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="end_time" :label="$t('getapi[7070]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="lock_r_code"
                                                 :label="$t('getapi[7071]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="Iss_InDate"
                                                 :label="$t('getapi[7072]')"></el-table-column>
                                <el-table-column prop="period_flag" :label="$t('getapi[12412]')">
                                    <template slot-scope="scope">
                                        <el-checkbox v-model="scope.row.period_flag" :true-label=1 :false-label=0></el-checkbox>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="period_hour" :label="$t('getapi[12413]')">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.period_hour" type="number" autocomplete="off" title="" @blur="scope.row.period_hour=Number(scope.row.period_hour)" @mousewheel.native.prevent style="width:100%"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="group_name" :label="$t('getapi[12444]')">
                                    <template slot-scope="scope">
                                        <el-input
                                                v-model="scope.row.group_name"
                                                type="text"
                                                readonly
                                                size="mini"
                                                style="width:100%"
                                                v-if="dataDetail.Head.so_status == 0 || scope.row.exclusively_id<=0"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectGroupName(scope)"></i>
                                        </el-input>
                                        <span v-if="dataDetail.Head.so_status != 0 && scope.row.exclusively_id>0">{{scope.row.group_name}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="workproc_id"  v-if="false" ></el-table-column>
                                <el-table-column prop="r_code" :label="$t('getapi[12445]')">
                                    <template slot-scope="scope">
                                        <el-input
                                                v-model="scope.row.r_code"
                                                type="text"
                                                readonly
                                                size="mini"
                                                style="width:100%"
                                                v-if="dataDetail.Head.so_status == 0 || scope.row.exclusively_id<=0"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectRCode(scope)"></i>
                                        </el-input>
                                        <span v-if="dataDetail.Head.so_status != 0 && scope.row.exclusively_id>0">{{scope.row.r_code}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" :label="$t('getapi[6048]')" width="100">
                                    <template slot-scope="scope">
                                        <el-popconfirm
                                                :confirmButtonText="$t('getapi[937]')"
                                                :cancelButtonText="$t('getapi[6]')"
                                                icon="el-icon-info"
                                                iconColor="red"
                                                :title="$t('getapi[637]')"
                                                @onConfirm="delLists(scope)"
                                        >
                                        <el-button slot="reference" type="text" size="small"
                                            :disabled="!btn.rowdellists || scope.row.isdel!=0 || (dataDetail.Head.so_type >=4 && dataDetail.Head.so_status>=3)">{{ $t('getapi[40]')}}</el-button>
                                        </el-popconfirm>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[4264]')" id="xdetilpane-1"  name="1">
                            <vxe-table
                                    :data="dataDetail.MasterLists"
                                    :loading="loadingDetail"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 188"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    resizable
                                    :auto-resize="true"
                                    show-overflow="tooltip"
                                    style="width: 100%; margin-top:5px"
                                    :sort-config="{
                                        trigger: 'cell',
                                        orders: ['desc', 'asc', null],
                                        sortMethod: sortChange
                                    }"
                            >
                                <vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')"
                                                  width="120" sortable header-align="center"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="part_name" :title="$t('getapi[116]')"
                                                  width="120" sortable></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')"
                                                  width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="part_model"
                                              :title="$t('getapi[124]')" sortable width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="part_spec"
                                              :title="$t('getapi[125]')" sortable width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="part_stuff"
                                              :title="$t('getapi[126]')" sortable width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="page_no"
                                              :title="$t('getapi[133]')" sortable width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="bomqty" :title="$t('getapi[4269]')"
                                                  align="right" width="120"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="bomhansun" :title="$t('getapi[4270]')"
                                                  align="right" width="120"></vxe-table-column>
                                <vxe-table-column field="so_stuff_qty" :title="$t('getapi[4245]')"
                                                  align="right" width="60">
                                    <template scope="scope">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent :disabled="readonly_so_stuff_qty && dataDetail.Head.so_type != 1"
                                                  v-model="scope.row.so_stuff_qty" @change="ChargestuffQty(scope)"></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="part_master_unit"
                                                  :title="$t('getapi[3260]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="total_issue_qty"
                                                  :title="$t('getapi[4272]')" align="right"
                                                  width="60"></vxe-table-column>
                                <!--<vxe-table-column show-footer-overflow field="total_return_qty"
                                                  :title="$t('getapi[1849]')" align="right"
                                                  width="60"></vxe-table-column>-->
                                <vxe-table-column show-footer-overflow field="part_assist_unit"
                                                  :title="$t('getapi[130]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="assist_total_issue_qty"
                                                  :title="$t('getapi[4273]')" align="right"
                                                  width="80"></vxe-table-column>
                                <!--<vxe-table-column show-footer-overflow field="assist_total_return_qty"
                                                  :title="$t('getapi[4274]')" align="right"
                                                  width="80"></vxe-table-column>-->
                                <vxe-table-column show-footer-overflow field="assembly_flag" :title="$t('getapi[7073]')" align="right"
                                                  width="80"></vxe-table-column>
                                <vxe-table-column field="so_stuff_status"
                                                  :title="$t('getapi[552]')" width="60">
                                    <template scope="scope">
                                        {{ expSoStuffStatus(scope.row.so_stuff_status) }}
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="modify_person" :title="$t('getapi[733]')"
                                                  width="60"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="modify_time" :title="$t('getapi[1210]')"
                                                  width="80"></vxe-table-column>
                                <vxe-table-column field="routing_sequence_no"
                                                  :title="$t('getapi[573]')" width="80">
                                    <template scope="scope">
                                        <!--<el-input size="mini" type="number" autocomplete="off" title="" v-model="scope.row.routing_sequence_no"></el-input>-->
                                        <el-select filterable v-model="scope.row.routing_sequence_no" size="mini"
                                                   @change="isCanChange(1, scope)" v-if="(dataDetail.Head.so_status == 0 || dataDetail.Head.so_status == 1 || dataDetail.Head.so_status == 2) && scope.row.total_issue_qty == 0">
                                            <el-option v-for="item in arrroutingsequenceno" :key="item.Code"
                                                       :title="item.Code" :value="item.Code"></el-option>
                                        </el-select>
                                        <span v-if="dataDetail.Head.so_status != 0 && dataDetail.Head.so_status != 1 && dataDetail.Head.so_status != 2 || scope.row.total_issue_qty != 0">{{scope.row.routing_sequence_no}}</span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="remark" :title="$t('getapi[143]')"
                                                  width="60">
                                    <template scope="scope">
                                        <el-input size="mini" type="text" v-model="scope.row.remark"></el-input>
                                    </template>
                                </vxe-table-column>
                                <!-- <vxe-table-column show-footer-overflow field="isedit" hidden="true" ></vxe-table-column> -->
                                <!--<el-table-column fixed="right" :label="$t('basic.edit')" width="50">
                                    <template slot-scope="scope">
                                        <el-popconfirm
                                                :confirmButtonText="$t('getapi[937]')"
                                                :cancelButtonText="$t('getapi[6]')"
                                                icon="el-icon-info"
                                                iconColor="red"
                                                :title="$t('getapi[637]')"
                                                @onConfirm="delMaster(scope)"
                                        >
                                            <el-button slot="reference" type="text" size="small" :disabled="!btn.rowdelmaster">{{
                                                $t('getapi[40]') }}
                                            </el-button>
                                        </el-popconfirm>
                                    </template>
                                </el-table-column>-->
                            </vxe-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[4276]')" id="xdetilpane-2"  name="2">
                            <div id="assist">
                            <el-table
                                    :data="dataDetail.AssistLists"
                                    @selection-change="handleSelectionChangeDetail2"
                                    :row-class-name="tableRowClassNameDetail2"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 230"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:5px"
                                    :header-cell-style="$limits.headerClass"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column prop="part_code" :label="$t('getapi[112]')"
                                                 width="150">
                                    <template scope="scope"
                                              v-if="dataDetail.Head.so_status == 0 || dataDetail.Head.so_status == 1 || dataDetail.Head.so_status == 2">
                                        <el-input v-model="scope.row.part_code" type="text" readonly class="mcolor"
                                                  size="mini">
                                            <i class="el-icon-edit el-input__icon" slot="suffix"
                                               @click="selectpartassist(scope)"></i>
                                        </el-input>
                                    </template>
                                </el-table-column>                                
                                <el-table-column show-footer-overflow prop="part_name" :label="$t('getapi[116]')"
                                                  width="120" ></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column show-footer-overflow prop="part_model" :label="$t('getapi[124]')"  width="80"></el-table-column>
                                <el-table-column show-footer-overflow prop="part_spec" :label="$t('getapi[125]')"  width="80"></el-table-column>
                                <el-table-column show-footer-overflow prop="part_stuff" :label="$t('getapi[126]')"  width="80"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_master_unit"
                                                 :label="$t('getapi[3260]')"></el-table-column>
                                <el-table-column prop="so_stuff_qty" :label="$t('getapi[4245]')"
                                                 align="right">
                                    <template scope="scope">
                                        <el-input v-model="scope.row.so_stuff_qty" :disabled="d_readonly_so_stuff_qty"
                                                  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="total_issue_qty"
                                                 :label="$t('getapi[4272]')" align="right"></el-table-column>
                                <!--<el-table-column show-overflow-tooltip prop="total_return_qty"
                                                 :label="$t('getapi[1849]')" align="right"></el-table-column>-->
                                <el-table-column show-overflow-tooltip prop="part_assist_unit"
                                                 :label="$t('getapi[130]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="assist_total_issue_qty"
                                                 :label="$t('getapi[4273]')" align="right"></el-table-column>
                                <!--<el-table-column show-overflow-tooltip prop="assist_total_return_qty"
                                                 :label="$t('getapi[4274]')" align="right"></el-table-column>-->
                                <el-table-column show-overflow-tooltip prop="create_person"
                                                 :label="$t('getapi[3099]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="create_time"
                                                 :label="$t('getapi[135]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="modify_person"
                                                 :label="$t('getapi[733]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="modify_time"
                                                 :label="$t('getapi[1210]')"></el-table-column>
                                <el-table-column prop="remark" :label="$t('getapi[1509]')">
                                    <template scope="scope"
                                              v-if="dataDetail.Head.so_status == 0 || dataDetail.Head.so_status == 1 || dataDetail.Head.so_status == 2">
                                        <el-input v-model="scope.row.remark" type="text" size="mini"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="routing_sequence_no"
                                                 :label="$t('getapi[573]')">
                                    <template scope="scope">
                                        <el-select filterable v-model="scope.row.routing_sequence_no" size="mini"
                                                   @change="isCanChange(2, scope)" v-if="(dataDetail.Head.so_status == 0 || dataDetail.Head.so_status == 1 || dataDetail.Head.so_status == 2)  && scope.row.total_issue_qty == 0">
                                            <el-option v-for="item in arrroutingsequenceno" :key="item.Code"
                                                       :label="item.Code" :value="item.Code"></el-option>
                                        </el-select>
                                        <span v-if="dataDetail.Head.so_status != 0 && dataDetail.Head.so_status != 1 && dataDetail.Head.so_status != 2  || scope.row.total_issue_qty != 0">{{scope.row.routing_sequence_no}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" :label="$t('getapi[6048]')" width="50">
                                    <template slot-scope="scope">
                                        <el-button slot="reference" type="text" size="small" @click="delAssist(scope)"
                                                   :disabled="!btn.rowdelassist || scope.row.total_issue_qty != ''">
                                            {{ $t('getapi[40]') }}
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            </div>
                            <table>
                                <tr>
                                    <td style="color: blue">{{ $t('getapi[7074]') }}</td>
                                </tr>
                                <tr>
                                    <td style="color: blue">{{ $t('getapi[7075]') }}</td>
                                </tr>
                                <tr>
                                    <td style="color: blue">{{ $t('getapi[7076]') }}</td>
                                </tr>
                            </table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[4281]')" id="xdetilpane-3"  name="3">
                            <el-table
                                    :data="dataDetail.IssLists"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 188"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:5px"
                            >
                                <el-table-column show-overflow-tooltip prop="ipo_code"
                                                 :label="$t('getapi[4283]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="ipo_line_no"
                                                 :label="$t('getapi[4284]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="so_code"
                                                 :label="$t('getapi[4285]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="routing_sequence_no"
                                                 :label="$t('getapi[4286]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code"
                                                 :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version"
                                                 :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="workproc_name"
                                                 :label="$t('getapi[574]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="unit_qty" :label="$t('getapi[4287]')"
                                                 align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="issue_total_qty"
                                                 :label="$t('getapi[4288]')" align="right"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[4289]')"  name="4">
                            <table>
                                <tr>
                                    <td style="width:60px">{{ $t('getapi[4290]') }}</td>
                                    <td style="width:100px;">
                                        <el-input type="text" size="mini" v-model="dataDetail.Head.relation_sr_code"
                                                  :disabled="true"></el-input>
                                    </td>
                                    <td style="width:60px">{{ $t('getapi[4291]') }}</td>
                                    <td style="width:100px;">
                                        <el-input type="text" size="mini" v-model="dataDetail.Head.start_working_date"
                                                  :disabled="true"></el-input>
                                    </td>
                                    <td style="width:60px">{{ $t('getapi[161]') }}</td>
                                    <td style="width:100px;">
                                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.produce_leadtime"
                                                  :disabled="true"></el-input>
                                    </td>
                                    <td style="width:60px">{{ $t('getapi[4214]') }}</td>
                                    <td style="width:100px;">
                                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.actual_finish_qty"
                                                  :disabled="true"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[550]') }}</td>
                                    <td>
                                        <el-input type="text" size="mini" v-model="dataDetail.Head.audit_person"
                                                  :disabled="true"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[732]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Head.audit_time" type="text" size="mini"
                                                  style="width:100%" :disabled="true"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[4216]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Head.actual_finish_date" type="text" size="mini"
                                                  style="width:100%" :disabled="true"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[4219]') }}</td>
                                    <td>
                                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.to_inv_qty"
                                                  :disabled="true"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[410]') }}</td>
                                    <td>
                                        <el-input type="text" size="mini" v-model="dataDetail.Head.create_person"
                                                  :disabled="true"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[2950]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Head.create_time" type="text" size="mini"
                                                  style="width:100%" :disabled="true"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[2358]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Head.force_close_time" type="text" size="mini"
                                                  style="width:100%" :disabled="true"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[4220]') }}</td>
                                    <td>
                                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.scrap_qty"
                                                  :disabled="true"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[5020]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Head.plan_audit_person" type="text" size="mini"
                                                  style="width:100%" :disabled="true"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[5021]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Head.plan_audit_time"
                                                  :disabled="true"></el-input>
                                    </td>
                                    <td><span v-if="userData.Login_DB == 'WOLVES' || userData.Login_DB == 'WOLVESTest'">{{ $t('getapi[8500]') }}</span></td>
                                    <td> <el-input v-if="userData.Login_DB == 'WOLVES' || userData.Login_DB == 'WOLVESTest'" v-model="dataDetail.Head.p_part"></el-input></td>
                                    <td>{{ $t('getapi[4906]') }}</td>
                                    <td>
                                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.rework_qty"
                                                  :disabled="true"></el-input>
                                    </td>
                                </tr>
                            </table>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize1"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 2" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize2"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total2"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 3" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange3"
                        @current-change="handleCurrentChange3"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize3"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total3"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 4" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange4"
                        @current-change="handleCurrentChange4"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize4"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total4"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 5" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange5"
                        @current-change="handleCurrentChange5"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize5"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total5"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 6" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange6"
                        @current-change="handleCurrentChange6"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize6"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total6"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ProSoMasterViewInfo" ref="ser" @getser="serclick"></serce>

        <el-dialog v-dialogDrag :visible.sync="visMPSInfo" width="80%" :close-on-click-modal="false">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[4168]') }}</td>
                    <td style="width:100px;">
                        <el-input type="text" size="mini" v-model="dataDetailMPS.Head.so_code"
                                  :disabled="true"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[4232]') }}</td>
                    <td style="width:60px;">
                        <el-input type="text" size="mini" v-model="dataDetailMPS.Head.so_status_name"
                                  disabled="true"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[112]') }}</td>
                    <td style="width:140px;">
                        <el-input type="text" size="mini" v-model="dataDetailMPS.Head.part_code"
                                  disabled="true"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[149]') }}</td>
                    <td style="width:60px;">
                        <el-input type="text" size="mini" v-model="dataDetailMPS.Head.part_version"
                                  disabled="true"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[4516]') }}</td>
                    <td style="width:60px;">
                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetailMPS.Head.plan_finish_qty"
                                  disabled="true"></el-input>
                    </td>
                </tr>
            </table>

            <div>
                <el-button type="primary" size="mini" @click="saveProSoReport(0)" :disabled="!btn.ProReport">{{
                    $t('getapi[4479]') }}
                </el-button>
            </div>
            <el-table
                    :data="dataDetailMPS.Lists"
                    @selection-change="handleSelectionChangeDetailMPS"
                    :highlight-current-row="true"
                    :height="tableHeight - 260"
                    border
                    size="mini"
                    style="width: 100%; margin-top:5px"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')"
                                 align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="workproc_name"
                                 :label="$t('getapi[574]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="routing_desc" :label="$t('getapi[575]')">
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="workcenter_name"
                                 :label="$t('getapi[882]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="hgqty" :label="$t('getapi[4790]')"
                                 align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="bfqty" :label="$t('getapi[4791]')"
                                 align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="remain_report_qty" :label="$t('getapi[4792]')"
                                 align="right"></el-table-column>
                <el-table-column prop="check_qty" :label="$t('getapi[1846]')" align="right">
                    <template scope="scope">
                        <el-input
                                type="number"
                                autocomplete="off" title=""
                                @mousewheel.native.prevent
                                size="mini"
                                v-model="scope.row.check_qty"
                                @onmouseenter="beforedatachange(scope)"
                                @change="datachange(scope)"
                                :disabled="!(scope.row.out_flag != 1 && scope.row.rights == 1)"
                        ></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="scrap_qty" :label="$t('getapi[4220]')" align="right">
                    <template scope="scope">
                        <el-input
                                type="number"
                                autocomplete="off" title=""
                                @mousewheel.native.prevent
                                size="mini"
                                v-model="scope.row.scrap_qty"
                                @onmouseenter="beforedatachange(scope)"
                                @change="datachange(scope)"
                                :disabled="!(scope.row.out_flag != 1 && scope.row.rights == 1 && $limits.authority('plv4', 123, 1) == 1)"
                        ></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="man_hour" :label="$t('getapi[4793]')" align="right">
                    <template scope="scope">
                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="scope.row.man_hour"
                                  :disabled="!(scope.row.out_flag != 1 && scope.row.rights == 1)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="jiaoyan" :label="$t('getapi[4794]')"></el-table-column>
                <el-table-column prop="remark" :label="$t('getapi[143]')">
                    <template scope="scope">
                        <el-input type="text" size="mini" v-model="scope.row.remark"
                                  :disabled="!(scope.row.out_flag != 1 && scope.row.rights == 1)"></el-input>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <!--选择物料-->
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true" :postUrl="'/Pro/SO/GetSOPartPopupDataList'"
                  @callback="getpart" ref="part"></selector>
        <!--工作中心-->
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true" :postUrl="'/Pro/SO/GetSOWorkPopupDataList'"
                  @callback="getworkcenter" ref="workcenter"></selector>
        <!--工序-->
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true" :postUrl="'/Pro/SO/GetSORoutingPopupDataList'"
                  @callback="getroute" ref="route"></selector>
        <!--选择物料-附加料表-->
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true"
                  :postUrl="'/Pro/SO/GetSOStuffPartPopupDataList'" @callback="getpartassist"
                  ref="partassist"></selector>
        <!--选择被替换物料-附加料表-->
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true"
                  :postUrl="'/Pro/SO/GetPartCodeReplacePopupList'" @callback="getreplacepart"
                  ref="replacepart"></selector>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SchPro/GetGroupNamePopupList'" @callback="getGroupName" ref="groupname"></selector>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SchPro/GetApsResourcePopupList'" @callback="getRCode" ref="rcode"></selector>
        <!-- 排序 -->
        <ctable :isVisible="false" title="SO一览" queryData="ProSoMasterViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="visSoBillCancel" :title="$t('getapi[4474]')" width="25%" :close-on-click-modal="false">
            <el-input type="textarea" size="mini" v-model="reason"></el-input>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visSoBillCancel = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmSoBillCancel" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visClose" :title="$t('getapi[1633]')" width="25%" :close-on-click-modal="false">
            <el-input type="textarea" size="mini" v-model="reasonclose"></el-input>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visClose = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmBillClose(0)" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visChangeRoutVer" :title="$t('getapi[7055]')" width="60%"
                   :close-on-click-modal="false">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[112]') }}</td>
                    <td style="width:100px;">
                        <el-input type="text" size="mini" v-model="dataDetailChangeRoutVer.Head.so_code"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[149]') }}</td>
                    <td style="width:100px;">
                        <el-input type="text" size="mini" v-model="dataDetailChangeRoutVer.Head.part_code"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[7077]') }}</td>
                    <td style="width:100px;">
                        <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                  v-model="dataDetailChangeRoutVer.Head.routing_version"></el-input>
                    </td>
                </tr>
            </table>

            <el-table :data="dataDetailChangeRoutVer.Lists" :highlight-current-row="true" :height="500" border
                      size="mini" style="width: 100%; margin-top:5px">
                <el-table-column show-overflow-tooltip prop="routing_version"
                                 :label="$t('getapi[547]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="version_status"
                                 :label="$t('getapi[552]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="enable_flag" :label="$t('getapi[555]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="freeze_reason"
                                 :label="$t('getapi[556]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="create_person"
                                 :label="$t('getapi[410]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="modify_person"
                                 :label="$t('getapi[733]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="audit_person"
                                 :label="$t('getapi[4043]')"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visChangeRoutVer = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmChangeRoutVer" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visReplacePart" :title="$t('getapi[4280]')" width="60%"
                   :close-on-click-modal="false">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[4483]') }}</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="replace_part_code" :disabled="true"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[4485]') }}</td>
                    <td style="width:150px;">
                        <el-input type="text" v-model="replace_sel_part_code" readonly class="mcolor" size="mini">
                            <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectreplacepart()"></i>
                        </el-input>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('getapi[4484]') }}</td>
                    <td>
                        <el-input type="text" size="mini" v-model="replace_part_version" :disabled="true"></el-input>
                    </td>
                    <td>{{ $t('getapi[4486]') }}</td>
                    <td>
                        <el-input type="text" size="mini" v-model="replace_sel_part_version"
                                  :disabled="true"></el-input>
                    </td>
                    <td>
                        <el-checkbox v-model="checkall" @change="checkAll"></el-checkbox>
                        全选
                    </td>
                </tr>
            </table>

            <el-table :data="dataDetailReplace" :highlight-current-row="true" :height="500" border size="mini"
                      style="width: 100%; margin-top:5px">
                <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4285]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="so_status" :label="$t('getapi[4489]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')"></el-table-column>
                <el-table-column prop="applicationto" :label="$t('getapi[4487]')">
                    <template scope="scope">
                        <el-checkbox v-model="scope.row.applicationto" true-label="1" false-label="0"></el-checkbox>
                    </template>
                </el-table-column>
            </el-table>
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[4483]') }}</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="filter_so_code"></el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[4485]') }}</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="filter_item_code"></el-input>
                    </td>
                    <td>
                        <el-button size="mini" @click="filter">{{ $t('getapi[4490]') }}</el-button>
                    </td>
                </tr>
            </table>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visReplacePart = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmBatchReplacePart" size="mini" :disabled="!btn.confirmBatchReplacePart">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="visDownType" :title="$t('getapi[922]')" width="35%" :close-on-click-modal="false" center>
            <table>
                <tr>                    
                    <td style="width:300px;border-right:2px solid #DCDFE6">{{ $t('getapi[922]') + $t('getapi[6384]') }}</td>
                    <td style="width:300px;">{{ $t('getapi[922]') + $t('getapi[6385]') }}</td>
                </tr>
                <tr>
                    <td style="width:60px;border-right:2px solid #DCDFE6">
                        <el-button type="primary"  size="mini" @click="WebShellExps()">{{ $t('getapi[12640]') }}</el-button>
                    </td>
                    <td style="width:60px"></td>
                </tr>
                <tr>
                    <td style="width:60px;border-right:2px solid #DCDFE6"><el-button type="primary"  size="mini" @click="exps(1)">{{ $t('getapi[12636]') }}</el-button></td>
                    <td style="width:60px"><el-button type="primary"  size="mini" @click="exps(2)">{{ $t('getapi[12637]') }}</el-button></td>
                </tr>
                <tr>                    
                    <td style="white-space: normal;border-right:2px solid #DCDFE6"><span style="color: red">{{ $t('getapi[12647]') }}</span></td>
                    <td style="white-space: normal"><span style="color: red">{{ $t('getapi[12646]') }}</span></td>
                </tr>
            </table>
		</el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '2_soview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight1_1,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight1_1,
                }
            },
            tableOption1() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight1_1,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight1_1,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                reduceTableHeight:Common.reduceTableHeight1_1,
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                addoredit: 0,
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_soview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                RightSelectIndex: 0, //右侧明细当前页面
                dataSet1: [], // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('2_soview1'), // 当前页数据量
                total1: 0, // 数据总量
                dataSet2: [], // 主表数据
                pageIndex2: 1, // 当前页
                pageSize2: this.$http.getPageSize('2_soview2'), // 当前页数据量
                total2: 0, // 数据总量
                dataSet3: [], // 主表数据
                pageIndex3: 1, // 当前页
                pageSize3: this.$http.getPageSize('2_soview3'), // 当前页数据量
                total3: 0, // 数据总量
                dataSet4: [], // 主表数据
                pageIndex4: 1, // 当前页
                pageSize4: this.$http.getPageSize('2_soview4'), // 当前页数据量
                total4: 0, // 数据总量
                dataSet5: [], // 主表数据
                pageIndex5: 1, // 当前页
                pageSize5: this.$http.getPageSize('2_soview5'), // 当前页数据量
                total5: 0, // 数据总量
                dataSet6: [], // 主表数据
                pageIndex6: 1, // 当前页
                pageSize6: this.$http.getPageSize('2_soview6'), // 当前页数据量
                total6: 0, // 数据总量
                loading: false, // 主表加载状态
                loadingDetail :false,
                dataDetail: {
                    Head: {},
                    Lists: [],
                    IssLists: [],
                    MasterLists: [],
                    AssistLists: []
                },
                selectData: [],
                selectData1: [],
                selectData2: [],
                selectData3: [],
                selectData4: [],
                selectData5: [],
                btn: {
                    batchRelease: false,
                    ISS: false,
                    listProReport: false,
                    ProReport: false,
                    Pro: false,
                    suspend: false,
                    recover: false,
                    rowdellists: false,
                    rowdelmaster: false,
                    rowdelassist: false,
                    batchReplacePart: false,
                    billRelease: false, // 下达
                    soBillCancel: false, //取消
                    billClose: false, //关闭
                    changeRoutVer: false, //切换工艺版本
                    manual_plan: false, // 人工流转
                    confirmBatchReplacePart: true,
                    gyzl: true,//最后一道工序完工数大于0，工艺指令按钮禁用
                    updateLLC:false,//更新底层码
                    duty: true,//批量更新责任单位
                },
                isSuspend: 3, //1 暂停 2 恢复 3默认 是否暂停
                visMPSInfo: false, // 是否显示执行汇报界面
                dataDetailMPS: {
                    Head: {},
                    Lists: []
                }, //执行汇报详情
                GHegeQty: '',
                GFanxiuQty: '',
                IssRemainQty: 0,

                rowindex_workcenter: '',
                oneormore_workcenter: 1,
                rowindex_partassist: '',
                oneormore_partassist: 1,
                rowindex_route: '',
                selectDataDetail: [],
                selectDataDetail2: [], //附加料表
                selectDataDetailMaster: [],
                selectDataDetailAssist: [],
                visSoBillCancel: false,
                reason: '',
                visClose: false,
                reasonclose: '',
                visChangeRoutVer: false,
                dataDetailChangeRoutVer: {
                    Head: {},
                    Lists: []
                },
                visReplacePart: false, //批量替换物料
                oldDataDetailReplace: [],
                dataDetailReplace: [],
                replace_so_code: '',
                replace_part_id: '',
                replace_part_code: '',
                replace_part_version: '',
                replace_sel_part_id: '',
                replace_sel_part_code: '',
                replace_sel_part_version: '',
                checkall: false,
                filter_so_code: '',
                filter_item_code: '',
                moveDirectionArr: [], //流转方向合集
                SignList: [], //配置批号合集
                routing_sequence_noArr: [], // 附加料表工序号合集
                arrroutingsequenceno: [],
                tableHeader: [],
                showbtn: 0, //明细按钮显示
                iss_self_bad_flag: true,//外协不良返修
                //主料表SO数量 只读
                readonly_so_stuff_qty: false,
                //附加料表SO数量 只读
                d_readonly_so_stuff_qty: false,
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                scrollTop: 0,
                scrollTop1: 0,
                scrollTop2: 0,
                scrollTop3: 0,
                scrollTop4: 0,
                scrollTop5: 0,
                visDownType: false, //下载类型弹窗控制
                downxlsfile:0,
                base_so_code:'',//返工汇报时传值，其他情况传递空值
            };
        },
        mounted: function () {
            /*this.$nextTick(() => {
                addEventListener('keyup', this.keyCopy); //创建监听键盘事件
            });*/
            let that = this;
            that.$nextTick(() => {
                addEventListener('paste', that.keyPaste);//创建键盘粘贴监听事件
            });
            that.colsort();
            that.$processdata.pushModelCache('2_soview', that);
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.downxlsfile= that.userData.downxlsfile;
            that.moveDirectionArr = Array.methods.getMoveDirection();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail);
            that.confirmAdd();
            that.$nextTick(function () {
                /*that.$processdata.initForm()
                that.$processdata.initFormRight()*/
            })

        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'issrelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
                if (form.name == 'prorelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
                if (form.name == 'reportdirectly' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getReworkDetail(data);
                    vm.base_so_code = data.base_so_code
                    setTimeout(() => {
                        vm.openEdit()
                    }, 1000);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        beforeDestroy() {
            removeEventListener('keyup', this.keyCopy);
        },
        activated () {   // 路由跳转回来滚动到离开时的位置
            let that = this
            setTimeout(() => {
                console.log(that.$refs.singleTable.$refs.singleTable.bodyWrapper)
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    let height = res.target
                    that.scrollTop = height.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
                that.$refs.singleTable4.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop4 = res.target.scrollTop
                },false)
                that.$refs.singleTable5.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop5 = res.target.scrollTop
                },false)
            }, 5000);
            this.$nextTick(()=> {
                setTimeout(() => {
                    that.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =that.scrollTop;
                    that.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =that.scrollTop1;
                    that.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =that.scrollTop2;
                    that.$refs.singleTable3.$refs.singleTable.bodyWrapper.scrollTop =that.scrollTop3;
                    that.$refs.singleTable4.$refs.singleTable.bodyWrapper.scrollTop =that.scrollTop4;
                    that.$refs.singleTable5.$refs.singleTable.bodyWrapper.scrollTop =that.scrollTop5;
                }, 13)
            })

        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4000]"),this.$t("getapi[25]"));
            },
            handleClick(tab, event) {
                console.log(tab.name, event);
                this.showbtn = tab.name;
                this.RightSelectIndex=tab.name
                /*this.$nextTick(function(){
                    this.$processdata.initFormRight(this.RightSelectIndex)
                });*/
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ProSoMasterViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            keyCopy(e) {
                let that = this;
                if (e.ctrlKey == true && e.keyCode == 67) {
                    e.returnValue = false;
                    //Ctrl+C事件
                    let allsocodes = '';
                    if (that.selectData.length > 0) {
                        //存入剪切板 SO_CODE
                        for (let j = 0; j < that.selectData.length; j++) {
                            allsocodes += that.selectData[j].SO_CODE + '\r\n';
                        }
                    }
                    if (that.selectData1.length > 0) {
                        //存入剪切板 SO_CODE
                        for (let j = 0; j < that.selectData1.length; j++) {
                            allsocodes += that.selectData1[j].SO_CODE + '\r\n';
                        }
                    }
                    if (that.selectData2.length > 0) {
                        //存入剪切板 SO_CODE
                        for (let j = 0; j < that.selectData2.length; j++) {
                            allsocodes += that.selectData2[j].SO_CODE + '\r\n';
                        }
                    }
                    if (that.selectData3.length > 0) {
                        //存入剪切板 SO_CODE
                        for (let j = 0; j < that.selectData3.length; j++) {
                            allsocodes += that.selectData3[j].SO_CODE + '\r\n';
                        }
                    }
                    if (that.selectData4.length > 0) {
                        //存入剪切板 SO_CODE
                        for (let j = 0; j < that.selectData4.length; j++) {
                            allsocodes += that.selectData4[j].SO_CODE + '\r\n';
                        }
                    }
                    if (that.selectData5.length > 0) {
                        //存入剪切板 SO_CODE
                        for (let j = 0; j < that.selectData5.length; j++) {
                            allsocodes += that.selectData5[j].SO_CODE + '\r\n';
                        }
                    }

                    if (!that.$limits.fnIsEmpty(allsocodes)) {
                        that.$message.success('复制成功！');
                        that.$copyText(allsocodes);
                        sessionStorage.setItem('socodes', allsocodes);
                    }
                }
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.readonly_so_stuff_qty = true;
                //开工、下达
                if(that.dataDetail.Head.so_type == 1 || that.dataDetail.Head.so_type == 3){
                    that.readonly_so_stuff_qty = false
                } else {
                    if (that.$limits.authority('plv4', 132, 1) == 1) {
                        that.readonly_so_stuff_qty = false;
                    }
                    else {
                        that.readonly_so_stuff_qty = true;
                    }
                }
                that.d_readonly_so_stuff_qty = true;
                //关闭、取消 只读
                if (that.dataDetail.Head.so_status == 0) {
                    //生成
                    that.d_readonly_so_stuff_qty = false;
                }
                else if (that.dataDetail.Head.so_status == 1 || that.dataDetail.Head.so_status == 2) {
                    //修改附加料表
                    if (that.$limits.authority('plv4', 365, 1) == 1) {
                        that.d_readonly_so_stuff_qty = false;
                        // this.dGViewPartList3.AllowUserToAddRows = true;
                    }
                    else {
                        that.d_readonly_so_stuff_qty = true;
                        // this.dGViewPartList3.AllowUserToAddRows = false;
                    }
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv4', 59, 1) == 0) {
                    that.authority_showprice = false;
                } else {
                    that.authority_showprice = true;
                }

                if (that.$limits.authority('plv4', 29, 1) == 0) {
                    that.authority_showdetailprice = false;
                } else {
                    that.authority_showdetailprice = true;
                }

                //管理界面
                if (that.$limits.authority('plv2', 181, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 181, 1) == 2) {
                    if (that.$limits.authority('plv3', 181, 1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 181, 1) == 1) {
                        //编辑级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.Head.so_code)) {
                            if (that.dataDetail.Head.so_status == 3 || that.dataDetail.Head.so_status == 4) {
                                that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,import');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,import');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,import');
                        }
                    }
                    if (that.$limits.authority('plv3', 181, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.Head.so_code)) {
                            if (that.dataDetail.Head.so_status > 0) {
                                if (that.dataDetail.Head.so_status == 3 || that.dataDetail.Head.so_status == 4) {
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,import');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,import');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,import');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,import');
                        }
                    }
                }
                else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    if (that.$limits.authority('plv2', 61, 1) > 0) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                }

                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.ISS = false;
                that.btn.listProReport = false;
                that.btn.ProReport = false;
                that.btn.Pro = false;
                that.btn.suspend = false;
                that.btn.recover = false;
                that.btn.updateLLC = false
                //更新底层码
                if (that.$limits.authority('plv4', 219, 1) == 0) {
                    that.btn.updateLLC = false;
                }
                else {
                    that.btn.updateLLC = true;
                }
                // 工艺指令
                if(that.dataDetail.Lists.length > 0){
                    if(that.dataDetail.Lists[that.dataDetail.Lists.length - 1].finish_qty > 0){
                        that.btn.gyzl = true
                    } else {
                        that.btn.gyzl = false
                    }
                } else {
                    that.btn.gyzl = false
                }
                //执行汇报权限
                if (that.$limits.authority('plv4', 122, 1) == 0) {
                    that.btn.ProReport = false;
                }
                else {
                    that.btn.ProReport = true;
                }

                if (that.SelectIndex == 0) {
                    if (that.selectData.length == 1) {
                        that.btn.ISS = true;
                        that.btn.Pro = true;
                    }
                } else if (that.SelectIndex == 1) {
                    if (that.selectData1.length == 1) {
                        that.btn.ISS = true;
                        that.btn.Pro = true;
                    }
                } else if (that.SelectIndex == 2) {
                    if (that.selectData2.length == 1) {
                        that.btn.ISS = true;
                        that.btn.Pro = true;
                        if (that.$limits.authority('plv4', 80, 1) == 1) {
                            that.btn.suspend = true;
                            that.btn.recover = true;
                        }
                        if (that.selectData2[0].pause_flag == '否') {
                            that.isSuspend = 1;
                        } else {
                            that.isSuspend = 2;
                        }
                        that.btn.listProReport = false;
                        if (that.selectData2[0].SO_Status == '下达' || that.selectData2[0].SO_Status == '开工') {
                            if (that.$limits.authority('plv4', 122, 1) == 1) {
                                that.btn.listProReport = true;
                            }
                        }
                    }
                    else if(that.selectData2.length > 1){
                        if (that.$limits.authority('plv4', 80, 1) == 1) {
                            that.btn.suspend = true;
                            that.btn.recover = true;
                        }
                        var strpause_flag="";
                        for(let i=0;i<that.selectData2.length;i++){
                            if(i==0){
                                strpause_flag=that.selectData2[0].pause_flag;
                            }
                            if(strpause_flag!=that.selectData2[i].pause_flag){
                                that.isSuspend=3;
                                return;
                            }
                            if (that.selectData2[i].pause_flag == '否') {
                                that.isSuspend = 1;
                            } else {
                                that.isSuspend = 2;
                            }
                        }
                        
                    }
                } else if (that.SelectIndex == 3) {
                    if (that.selectData3.length == 1) {
                        that.btn.ISS = true;
                        that.btn.Pro = true;
                        if (that.$limits.authority('plv4', 80, 1) == 1) {
                            that.btn.suspend = true;
                            that.btn.recover = true;
                        }
                        if (that.selectData3[0].pause_flag == '否') {
                            that.isSuspend = 1;
                        } else {
                            that.isSuspend = 2;
                        }
                        that.btn.listProReport = false;
                        if (that.selectData3[0].SO_Status == '下达' || that.selectData3[0].SO_Status == '开工') {
                            if (that.$limits.authority('plv4', 122, 1) == 1) {
                                that.btn.listProReport = true;
                            }
                        }
                    }
                    else if(that.selectData3.length > 1){
                        if (that.$limits.authority('plv4', 80, 1) == 1) {
                            that.btn.suspend = true;
                            that.btn.recover = true;
                        }
                        strpause_flag="";
                        for(let i=0;i<that.selectData3.length;i++){
                            if(i==0){
                                strpause_flag=that.selectData3[0].pause_flag;
                            }
                            if(strpause_flag!=that.selectData3[i].pause_flag){
                                that.isSuspend=3;
                                return;
                            }
                            if (that.selectData3[i].pause_flag == '否') {
                                that.isSuspend = 1;
                            } else {
                                that.isSuspend = 2;
                            }
                        }
                        
                    }
                } else if (that.SelectIndex == 5) {
                    if (that.selectData5.length == 1) {
                        that.btn.ISS = true;
                        that.btn.Pro = true;
                    }
                }
                that.btn.batchRelease = false;
                if (that.$limits.authority('plv4', 134, 1) == 1) {
                    if (that.selectData1.length > 0) {
                        that.btn.batchRelease = true;
                    }
                }
                that.btn.billRelease = false; // 下达
                that.btn.soBillCancel = false; //取消
                that.btn.billClose = false; //关闭
                that.btn.changeRoutVer = false; //切换工艺版本
                if (that.dataDetail.Head.so_status == 0) {
                    if (that.$limits.authority('plv3', 181, 1) > 0) {
                        if (that.$limits.authority('plv4', 106, 1) == 0) {
                            that.btn.billRelease = false;
                        }
                        if (that.$limits.authority('plv4', 106, 1) == 1) {
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.so_code)) {
                                that.btn.billRelease = true;
                            }
                            else {
                                that.btn.billRelease = false;
                            }
                        }
                        /*if (that.$limits.authority('plv4', 107, 1) == 0) {
                            that.btn.soBillCancel = false;
                        }
                        if (that.$limits.authority('plv4', 107, 1) == 1) {
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.so_code)) {
                                that.btn.soBillCancel = true;
                            }
                            else {
                                that.btn.soBillCancel = false;
                            }
                        }*/
                        if (that.$limits.authority('plv4', 149, 1) == 1) {
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.so_code)) {
                                that.btn.changeRoutVer = true;
                            }
                            else {
                                that.btn.changeRoutVer = false;
                            }
                        }
                    }
                    that.btn.billClose = false;
                }
                if (that.dataDetail.Head.so_status == 1) {
                    if (that.$limits.authority('plv3', 181, 1) > 0) {
                        if (that.$limits.authority('plv4', 107, 1) == 0) {
                            that.btn.soBillCancel = false;
                        }
                        if (that.$limits.authority('plv4', 107, 1) == 1) {
                            that.btn.soBillCancel = true;
                        }
                    }
                    that.btn.billRelease = false;
                    that.btn.billClose = false;
                    that.btn.changeRoutVer = false;
                }
                if (that.dataDetail.Head.so_status == 2) {
                    if (that.$limits.authority('plv3', 181, 1) > 0) {
                        if (that.$limits.authority('plv4', 108, 1) == 0) {
                            that.btn.billClose = false;
                        }
                        if (that.$limits.authority('plv4', 108, 1) == 1) {
                            that.btn.billClose = true;
                        }
                    }
                    that.btn.billRelease = false;
                    that.btn.soBillCancel = false;
                    that.btn.changeRoutVer = false;
                }
                if (that.dataDetail.Head.so_status == 3) {
                    that.btn.billRelease = false;
                    that.btn.soBillCancel = false;
                    that.btn.billClose = false;
                    that.btn.changeRoutVer = false;
                }
                if (that.dataDetail.Head.so_status == 4) {
                    that.btn.billRelease = false;
                    that.btn.soBillCancel = false;
                    that.btn.billClose = false;
                    that.btn.changeRoutVer = false;
                }
                that.btn.rowdellists = false;
                that.btn.rowdelmaster = false;
                that.btn.batchReplacePart = false;
                that.btn.rowdelassist = false;
                                  
                if (that.$limits.authority('plv4', 263, 1) == 1) {
                    // if (that.dataDetail.Head.so_type == '返修') {
                    //     if (that.dataDetail.Head.so_status == 2 || that.dataDetail.Head.so_status == 3 || that.dataDetail.Head.so_status == 4) {
                    //         that.btn.rowdellists = false;
                    //     } else {
                    //         that.btn.rowdellists = true;
                    //     }
                    // } else {
                        // that.dataDetail.Head.so_status == 1 || that.dataDetail.Head.so_status == 2 ||
                        if (that.dataDetail.Head.so_status == 3 || that.dataDetail.Head.so_status == 4) {
                            that.btn.rowdellists = false;
                        } else {
                            that.btn.rowdellists = true;
                        }
                    // }
                }
                if (that.dataDetail.Head.so_status == 3 || that.dataDetail.Head.so_status == 4) {
                    that.btn.batchReplacePart = false;
                    that.btn.rowdelassist = false;
                } else {
                    if (that.selectDataDetail2.length == 1 && that.selectDataDetail2[0].exclusively_id != '') {
                        if (that.$limits.authority('plv4', 358, 1) == 0) {
                            that.btn.batchReplacePart = false;
                        }
                        if (that.$limits.authority('plv4', 358, 1) == 1) {
                            that.btn.batchReplacePart = true;
                        }
                    }
                    if (that.$limits.authority('plv4', 365, 1) == 1) {
                        that.btn.rowdelassist = true;
                    } else {
                        that.btn.rowdelassist = false;
                    }
                }
                if (that.$limits.authority('plv4', 263, 1) == 0) {
                    that.btn.rowdellists = false;
                }
               
                // 物料删除权限
                if (that.$limits.authority('plv2', 181, 1) == 2) {
                    if (that.$limits.authority('plv3', 181, 1) >= 1) {
                        if (that.dataDetail.Head.so_status == 1 || that.dataDetail.Head.so_status == 0) {
                            if (that.dataDetail.Head.so_code == '') {
                                if (that.dataDetail.Head.so_type == '返修') {
                                    that.btn.rowdelmaster = true;
                                }
                            } else {
                                if (that.dataDetail.Head.so_code != '') {
                                    that.getOldSOType();
                                }
                            }
                        }
                    }
                }
                that.btn.manual_plan = false;
                if (that.$limits.authority('plv4', 162, 1) == 1) {
                    that.btn.manual_plan = true;
                }
            },
            getOldSOType() {
                let that = this;
                let parm = {
                    Code: that.dataDetail.Head.so_code
                };
                that.$http.urlpost('/Pro/SO/GetOldSO_Type', parm, function (res) {
                    if (res.Success == 1) {
                        if (res.Totals == 1) {
                            that.btn.rowdelmaster = true;
                        }
                    }
                });
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                //无保存权限直接关闭
                if(that.$limits.authority('plv3', 181,1) < 1){
                    let left = document.getElementsByClassName('left');
                    let mid = document.getElementsByClassName('mid');
                    let Box = document.getElementsByClassName('Boxs');
                    let bw = Box[0].clientWidth;
                    left[0].style.width = '100%';
                    mid[0].style.width = '0px'
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.MasterLists.length;i++){
                    delete datacopy.MasterLists[i]['_XID'];
                }
                for(let i = 0;i<datacopy.AssistLists.length;i++){
                    delete datacopy.AssistLists[i]['index'];
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//数据已发生变更，是否保存后关闭
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        closeOnClickModal: false,
                        type: 'warning'
                    })
                        .then(() => {
                            that.saveAndClose(0)
                        })
                        .catch(() => {
                            that.confirmAdd()
                            let left = document.getElementsByClassName('left');
                            let mid = document.getElementsByClassName('mid');
                            let Box = document.getElementsByClassName('Boxs');
                            let bw = Box[0].clientWidth;
                            left[0].style.width = '100%';
                            mid[0].style.width = '0px'
                        });
                } else {
                    let left = document.getElementsByClassName('left');
                    let mid = document.getElementsByClassName('mid');
                    let Box = document.getElementsByClassName('Boxs');
                    let bw = Box[0].clientWidth;
                    left[0].style.width = '100%';
                    mid[0].style.width = '0px'
                }
            },
            saveAndClose(val){
                let that = this;
                // 判断工序号是否重复
                let arr = [];
                if (that.dataDetail.Lists.length > 1) {
                    for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                        if (that.dataDetail.Lists[i].routing_sequence_no == '') {
                            that.$message.warning(that.$t('getapi[8593]'));//工序号不能重复！
                            return;
                        }
                    }
                }
                if(that.dataDetail.AssistLists.length > 1){
                    for(let i = 0;i<that.dataDetail.AssistLists.length;i++){
                        for(let j=i+1;j<that.dataDetail.AssistLists.length;j++)
                            if(that.dataDetail.AssistLists[i].part_code + that.dataDetail.AssistLists[i].part_version +  that.dataDetail.AssistLists[i].routing_sequence_no == that.dataDetail.AssistLists[j].part_code + that.dataDetail.AssistLists[j].part_version +  that.dataDetail.AssistLists[j].routing_sequence_no){
                                that.$message.warning(that.$t('getapi[8847]'));//附加料表相同物料工序相同
                                return
                            }
                    }
                }
                that.dataDetail.Head.iscontinue = val;
                let parm = {
                    Head: that.dataDetail.Head,
                    Lists: that.dataDetail.Lists,
                    MasterLists: that.dataDetail.MasterLists,
                    AssistLists: that.dataDetail.AssistLists,
                    LangType:that.$processdata.getLang(),
                };
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/Pro/SO/SOSaveData', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.confirmAdd()
                        let left = document.getElementsByClassName('left');
                        let mid = document.getElementsByClassName('mid');
                        let Box = document.getElementsByClassName('Boxs');
                        let bw = Box[0].clientWidth;
                        left[0].style.width = '100%';
                        mid[0].style.width = '0px'
                    } else if (res.Success > 1) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.saveAndClose(res.Success);
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            selectChanaged(value) {
                let that = this
                if (value == "返修" || value == 1) {
                    this.iss_self_bad_flag = false;
                }
                else {
                    this.iss_self_bad_flag = true;
                    this.dataDetail.Head.iss_self_bad_flag = 0;
                    this.dataDetail.Head.iss_venderreason_flag = 0
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_soview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.$http.savePageSize('2_soview1',val)
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.$http.savePageSize('2_soview2',val)
                this.getView();
            },
            handleCurrentChange2(val) {
                this.pageIndex2 = val;
                this.getView();
            },
            handleSizeChange3(val) {
                this.pageSize3 = val;
                this.$http.savePageSize('2_soview3',val)
                this.getView();
            },
            handleCurrentChange3(val) {
                this.pageIndex3 = val;
                this.getView();
            },
            handleSizeChange4(val) {
                this.pageSize4 = val;
                this.$http.savePageSize('2_soview4',val)
                this.getView();
            },
            handleCurrentChange4(val) {
                this.pageIndex4 = val;
                this.getView();
            },
            handleSizeChange5(val) {
                this.pageSize5 = val;
                this.$http.savePageSize('2_soview5',val)
                this.getView();
            },
            handleCurrentChange5(val) {
                this.pageIndex5 = val;
                this.getView();
            },
            handleSizeChange6(val) {
                this.pageSize6 = val;
                this.$http.savePageSize('2_soview6',val)
                this.getView();
            },
            handleCurrentChange6(val) {
                this.pageIndex6 = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
                /*that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });*/
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProSoMasterViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                if(that.SelectIndex == 1){
                    data.PageIndex = that.pageIndex1
                    data.PageSize = that.pageSize1
                } else if(that.SelectIndex == 2){
                    data.PageIndex = that.pageIndex2
                    data.PageSize = that.pageSize2
                } else if(that.SelectIndex == 3){
                    data.PageIndex = that.pageIndex3
                    data.PageSize = that.pageSize3
                } else if(that.SelectIndex == 4){
                    data.PageIndex = that.pageIndex4
                    data.PageSize = that.pageSize4
                } else if(that.SelectIndex == 5){
                    data.PageIndex = that.pageIndex5
                    data.PageSize = that.pageSize5
                } else if(that.SelectIndex == 6){
                    data.PageIndex = that.pageIndex6
                    data.PageSize = that.pageSize6
                }
                that.$http.urlpost('/Pro/SO/SOViewDataList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        } else if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        } else if (that.SelectIndex == 2) {
                            that.dataSet2 = res.DataContent;
                            that.total2 = res.Totals;
                        } else if (that.SelectIndex == 3) {
                            that.dataSet3 = res.DataContent;
                            that.total3 = res.Totals;
                        } else if (that.SelectIndex == 4) {
                            that.dataSet4 = res.DataContent;
                            that.total4 = res.Totals;
                        } else if (that.SelectIndex == 5) {
                            that.dataSet5 = res.DataContent;
                            that.total5 = res.Totals;
                        } else if (that.SelectIndex == 6) {
                            that.dataSet6 = res.DataContent;
                            that.total6 = res.Totals;
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.$nextTick(function(){
                            that.$processdata.initAllForm()
                            //that.$processdata.initForm(that.SelectIndex)
                        });
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 根据ID获取详情数据
            edits({row}) {
                let that = this;
                console.log(row)
                if(that.code == row.SO_CODE){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.MasterLists.length;i++){
                        delete datacopy.MasterLists[i]['_XID'];
                    }
                    for(let i = 0;i<datacopy.AssistLists.length;i++){
                        delete datacopy.AssistLists[i]['index'];
                    }
                    if (that.oldDataDetail != JSON.stringify(datacopy)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.SO_CODE;
                                that.getDetail(row.SO_CODE);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.SelectIndex == 0) {
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 1) {
                                    that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 2) {
                                    that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 3) {
                                    that.$refs.singleTable3.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 4) {
                                    that.$refs.singleTable4.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 5) {
                                    that.$refs.singleTable5.$refs.singleTable.setCurrentRow(that.oldrow);
                                }
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.SO_CODE;
                        that.getDetail(row.SO_CODE);
                    }
                }, 100);
            },
            //导入
            impt() {

                let item = {
                    //label: 'SO导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/18',
                    url: '/exp/18',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/18'});
                this.$store.commit('selectMenu', item);
            },
            // 新增
            add() {
                let that = this;
                that.base_so_code = ''
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.MasterLists.length;i++){
                    delete datacopy.MasterLists[i]['_XID'];
                }
                for(let i = 0;i<datacopy.AssistLists.length;i++){
                    delete datacopy.AssistLists[i]['index'];
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save();
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd();
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd();
                }
            },
            confirmAdd() {
                let that = this;
                that.code = ''
                that.addoredit = 0;
                that.dataDetail.Head = {
                    so_code: '',
                    parent_so_code: '',
                    coll_sign: '',
                    part_code: '',
                    part_version: '',
                    part_id: '',
                    item_code: '',
                    schedule_no: '',
                    relation_sr_code: '',
                    plan_finish_qty: 1,
                    actual_finish_qty: '',
                    plan_finish_date: '',
                    actual_finish_date: '',
                    start_working_date: '',
                    produce_leadtime: '',
                    so_status: 0,
                    to_inv_qty: 0,
                    direct_stuff_move_flag: '0',
                    move_direction: '',
                    create_person: '',
                    create_time: '',
                    modify_person: '',
                    modify_time: '',
                    audit_person: '',
                    audit_time: '',
                    cancel_person: null,
                    cancel_reason: null,
                    cancel_time: null,
                    remark1: '',
                    remark2: null,
                    field: null,
                    setcollection: 0,
                    scrap_qty: 0,
                    rework_qty:0,
                    finished_product_receive: 0,
                    manual_plan: '0',
                    report_lock_time_stamp: null,
                    force_close_flag: '0',
                    force_close_person: '',
                    force_close_time: '',
                    force_close_reason: '',
                    coll_person: null,
                    coll_time: null,
                    llc: 0,
                    so_type: '0',
                    new_flag: 0,
                    bom_config_flag: '0',
                    bom_config_sign: '',
                    bad_qty: 0,
                    iss_self_bad_flag: '0',
                    calc_flag: 0,
                    concurrent_time: '',
                    routing_version: '',
                    pause_flag: '0',
                    trace: 0,
                    iss_venderreason_flag: '0',
                    need_schedule: 0,
                    already_schedule: 0,
                    lock_schedule: 0,
                    isadd: 1,
                    iscontinue: 0,
                    routing_remark:'',
                    print_batch_no:'',
                    mrb_no:'',
                    p_part:'',
                };
                that.dataDetail.Lists = [];
                that.dataDetail.IssLists = [];
                that.dataDetail.MasterLists = [];
                that.dataDetail.AssistLists = [];
                that.oldDataDetail = JSON.stringify(that.dataDetail);
                that.authority();
            },
            // 刷新
            reflash() {
                /*let that = this;
                if(that.addoredit == 0){
                    that.add()
                } else {
                    that.getDetail(that.code)
                }
                that.getView();*/
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.MasterLists.length;i++){
                    delete datacopy.MasterLists[i]['_XID'];
                }
                for(let i = 0;i<datacopy.AssistLists.length;i++){
                    delete datacopy.AssistLists[i]['index'];
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save();
                        })
                        .catch(() => {
                            if (that.addoredit == 0) {
                                that.getView();
                                that.confirmAdd();
                            } else {
                                that.getView();
                                that.getDetail(that.code);
                            }
                        });
                } else {
                    if (that.addoredit == 0) {
                        that.getView();
                        that.confirmAdd();
                    } else {
                        that.getView();
                        that.getDetail(that.code);
                    }
                }
            },
            //导出弹窗
            expjqdialog() {
                let that = this;
                if(that.downxlsfile==1){
                    that.visDownType=true;
                }
                else{
                    that.exps(2);
                }
            },
            WebShellExps(){                
                let that = this;          
                let hrefurl = Common.InUrl + "/help/WebShellExps.zip";
                window.open(hrefurl);
            },
            // 导出
            exps(type) {
                
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ProSoMasterViewInfo",
                    fromname: that.$t('getapi[4000]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                
                if(type==1){
                    //本地插件导出
                    that.$processdata.commonPlugInExport(parm)
                }
                else{
                    that.$processdata.commonExport(parm)
                }
                that.visDownType=false;
                // that.$processdata.commonExport(parm)
            },
            //查看图纸
            lct(val) {
                let that = this
                let item = {
                    //技术文档
                    label:  this.$t('getapi[6575]'),
                    name: 'docmanageview',
                    path: '/docmanageview',
                    url: '/docmanageview',
                    icon: 'video-play'
                };
                that.$store.commit('setSharedParams', {
                    schedule_no: val.row.SO_CODE
                });
                this.$router.push({ path: '/docmanageview'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            // 保存
            save(val) {
                let that = this;
                // 判断工序号是否重复
                let arr = [];
                if (that.dataDetail.Lists.length > 1) {
                    for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                        if (that.dataDetail.Lists[i].routing_sequence_no == '') {
                            that.$message.warning(that.$t('getapi[8593]'));//工序号不能重复！
                            return;
                        }
                    }
                }
                if(that.dataDetail.AssistLists.length > 1){
                    for(let i = 0;i<that.dataDetail.AssistLists.length;i++){
                        for(let j=i+1;j<that.dataDetail.AssistLists.length;j++)
                        if(that.dataDetail.AssistLists[i].part_code + that.dataDetail.AssistLists[i].part_version +  that.dataDetail.AssistLists[i].routing_sequence_no == that.dataDetail.AssistLists[j].part_code + that.dataDetail.AssistLists[j].part_version +  that.dataDetail.AssistLists[j].routing_sequence_no){
                            that.$message.warning(that.$t('getapi[8847]'));//'附加料表相同物料工序相同'
                            return
                        }
                    }
                }
                that.dataDetail.Head.iscontinue = val;
                let parm = {
                    Head: that.dataDetail.Head,
                    Lists: that.dataDetail.Lists,
                    MasterLists: that.dataDetail.MasterLists,
                    AssistLists: that.dataDetail.AssistLists,
                    LangType:that.$processdata.getLang(),
                };
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/Pro/SO/SOSaveData', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.code = res.UniqueNum;
                        that.getDetail(res.UniqueNum);
                    } else if (res.Success > 1) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.save(res.Success);
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            getDetail(val) {
                // type:1 获取详情 2：转单获取详情
                let that = this;
                console.log('权限' + that.$limits.authority('plv2', 181, 1))
                if (that.$limits.authority('plv2', 181, 1) < 1) {
                    return
                }
                that.addoredit = 1;
                let parm = {
                    Code: val,
                    LangType:that.$processdata.getLang()
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pro/SO/GetSOBillInfoBySoCode', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.dataDetail.Head.force_close_flag = that.dataDetail.Head.force_close_flag.toString();
                        that.dataDetail.Head.so_type = that.dataDetail.Head.so_type.toString();
                        that.dataDetail.Head.new_flag = that.dataDetail.Head.new_flag.toString();
                        that.dataDetail.Head.direct_stuff_move_flag = that.dataDetail.Head.direct_stuff_move_flag.toString();
                        that.dataDetail.Head.manual_plan = that.dataDetail.Head.manual_plan.toString();
                        that.dataDetail.Head.bom_config_flag = that.dataDetail.Head.bom_config_flag.toString();
                        that.dataDetail.Head.iss_self_bad_flag = that.dataDetail.Head.iss_self_bad_flag.toString();
                        that.dataDetail.Head.iss_venderreason_flag = that.dataDetail.Head.iss_venderreason_flag.toString();
                        that.dataDetail.Head.pause_flag = that.dataDetail.Head.pause_flag.toString();
                        that.dataDetail.Head.need_schedule = that.dataDetail.Head.need_schedule.toString();
                        that.dataDetail.Head.already_schedule = that.dataDetail.Head.already_schedule.toString();
                        that.dataDetail.Head.lock_schedule = that.dataDetail.Head.lock_schedule.toString();
                        that.dataDetail.Head.plan_finish_date = new Date(that.dataDetail.Head.plan_finish_date)
                        that.oldDataDetail = JSON.stringify(that.dataDetail);
                        that.updateArr();
                        that.authority();
                        that.btnauthority();
                        that.$nextTick(function(){
                            that.$processdata.initAllForm()
                            //that.$processdata.initForm(this.SelectIndex)
                            //that.$processdata.initFormRight(this.RightSelectIndex)
                        });
                    }
                    loadingInstance.close()
                });
            },
            getReworkDetail(data){
                let that = this
                that.code = ''
                that.addoredit = 0;
                let parm = data
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pro/SO/CreateRework', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.dataDetail.Head.force_close_flag = that.dataDetail.Head.force_close_flag.toString();
                        that.dataDetail.Head.so_type = that.dataDetail.Head.so_type.toString();
                        that.dataDetail.Head.new_flag = that.dataDetail.Head.new_flag.toString();
                        that.dataDetail.Head.direct_stuff_move_flag = that.dataDetail.Head.direct_stuff_move_flag.toString();
                        that.dataDetail.Head.manual_plan = that.dataDetail.Head.manual_plan.toString();
                        that.dataDetail.Head.bom_config_flag = that.dataDetail.Head.bom_config_flag.toString();
                        that.dataDetail.Head.iss_self_bad_flag = that.dataDetail.Head.iss_self_bad_flag.toString();
                        that.dataDetail.Head.iss_venderreason_flag = that.dataDetail.Head.iss_venderreason_flag.toString();
                        that.dataDetail.Head.pause_flag = that.dataDetail.Head.pause_flag.toString();
                        that.dataDetail.Head.need_schedule = that.dataDetail.Head.need_schedule.toString();
                        that.dataDetail.Head.already_schedule = that.dataDetail.Head.already_schedule.toString();
                        that.dataDetail.Head.lock_schedule = that.dataDetail.Head.lock_schedule.toString();
                        that.dataDetail.Head.isadd = 1;
                        that.oldDataDetail = JSON.stringify(that.dataDetail);
                        that.updateArr();
                        that.authority();
                        that.btnauthority();
                        that.$nextTick(function(){
                            that.$processdata.initAllForm()
                        });
                    }
                    loadingInstance.close()
                });
            },
            handleSelectionChange({ checked,records }) {
                let that = this;
                that.selectData = records;
                that.btnauthority();
            },
            handleSelectionChangeAll({ records }){
                let that = this
                this.selectData = records;
                that.btnauthority()
            },
            handleSelectionChange1({ checked,records }) {
                let that = this;
                that.selectData1 = records;
                that.btnauthority();
            },
            handleSelectionChangeAll1({ records }){
                let that = this
                this.selectData1 = records;
                that.btnauthority()
            },
            handleSelectionChange2({ checked,records }) {
                let that = this;
                that.selectData2 = records;
                that.btnauthority();
            },
            handleSelectionChangeAll2({ records }){
                let that = this
                this.selectData2 = records;
                that.btnauthority()
            },
            handleSelectionChange3({ checked,records }) {
                let that = this;
                that.selectData3 = records;
                that.btnauthority();
            },
            handleSelectionChangeAll3({ records }){
                let that = this
                this.selectData3 = records;
                that.btnauthority()
            },
            handleSelectionChange4({ checked,records }) {
                let that = this;
                that.selectData4 = records;
                that.btnauthority();
            },
            handleSelectionChangeAll4({ records }){
                let that = this
                this.selectData4 = records;
                that.btnauthority()
            },
            handleSelectionChange5({ checked,records }) {
                let that = this;
                that.selectData5 = records;
                that.btnauthority();
            },
            handleSelectionChangeAll5({ records }){
                let that = this
                this.selectData5 = records;
                that.btnauthority()
            },
            handleSelectionChange6({ checked,records }) {
                let that = this;
                that.selectData6 = records;
                that.btnauthority();
            },
            handleSelectionChangeAll6({ records }){
                let that = this
                this.selectData6 = records;
                that.btnauthority()
            },
            // 外协业务图
            getISS() {
                let that = this;
                let data = {};
                if (that.SelectIndex == 0) {
                    data = that.selectData[0];
                } else if (that.SelectIndex == 1) {
                    data = that.selectData1[0];
                } else if (that.SelectIndex == 2) {
                    data = that.selectData2[0];
                } else if (that.SelectIndex == 3) {
                    data = that.selectData3[0];
                } else if (that.SelectIndex == 5) {
                    data = that.selectData5[0];
                }
                that.$store.commit('setSharedParams', data);
                let item = {
                    label: '外协关系图',
                    name: 'issrelation',
                    path: '/issrelation/so',
                    url: '/issrelation/so',
                    icon: 'video-play'
                };
                this.$router.push({path: '/issrelation/so'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item);
            },
            // 生产业务图
            getPro() {
                let that = this;
                let data = {};
                if (that.SelectIndex == 0) {
                    data = that.selectData[0];
                } else if (that.SelectIndex == 1) {
                    data = that.selectData1[0];
                } else if (that.SelectIndex == 2) {
                    data = that.selectData2[0];
                } else if (that.SelectIndex == 3) {
                    data = that.selectData3[0];
                } else if (that.SelectIndex == 5) {
                    data = that.selectData5[0];
                }
                that.$store.commit('setSharedParams', data);
                let item = {
                    label: '生产关系图',
                    name: 'prorelation',
                    path: '/prorelation/so',
                    url: '/prorelation/so',
                    icon: 'video-play'
                };
                this.$router.push({path: '/prorelation/so'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item);
            },
            // 更新SO入库
            soInQty() {
                let that = this;
                let parm = {};
                that.$http.urlpost('/Pro/SO/SOInQty', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getView();
                    }
                });
            },
            //批量下达
            batchRelease() {
                let that = this;
                let arr = [];
                if (that.selectData1.length == 0) {
                    that.$message.warning(that.$t('getapi[1158]'));//请选择数据！
                    return;
                }
                for (let i = 0; i < that.selectData1.length; i++) {
                    arr = [
                        ...arr,
                        {
                            so_code: that.selectData1[i].SO_CODE,
                            part_code: that.selectData1[i].Part_Code,
                            part_version: that.selectData1[i].Part_version,
                            plan_finish_qty: that.selectData1[i].Plan_Finish_qty,
                            new_flag: that.selectData1[i].new_flag
                        }
                    ];
                }
                let parm = {
                    Lists: arr,
                    LangType:that.$processdata.getLang()
                };
                that.btn.batchRelease = false
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Pro/SO/SORelease', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getView();
                    }
                    that.btn.batchRelease = true
                    loadingInstance.close()
                });
            },
            getMPSBillInfo() {
                let that = this;
                /*that.visMPSInfo = true;*/
                let parm = {};
                if (that.SelectIndex == 2) {
                    parm = {
                        Code: that.selectData2[0].SO_CODE
                    };
                } else if (that.SelectIndex == 3) {
                    parm = {
                        Code: that.selectData3[0].SO_CODE
                    };
                }
                that.$store.commit('setSharedParams', parm);
                let item = {
                    label: that.$t('getapi[4788]'),//'直接汇报'
                    name: 'reportdirectly',
                    path: '/reportdirectly',
                    url: '/reportdirectly',
                    icon: 'video-play'
                };
                this.$router.push({path: '/reportdirectly'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
                /*that.$http.urlpost('/Pro/SO/GetMPSBillInfo', parm, function(res) {
				if (res.Success == 1) {
					that.dataDetailMPS = res.DataContent;
					that.IssRemainQty = that.getIssRemainQty();
					that.btn.check_qty = false;
					that.btn.scrap_qty = false;
					that.btn.man_hour = false;
					that.btn.remark = false;
					for(let i = 0;i<that.dataDetailMPS.Lists.length;i++){
                        if (!that.$limits.fnIsEmpty(that.dataDetailMPS.Lists[i].jiaoyan)) {
							that.btn.ProReport=false;
						}
					}
					/!*for(let i = 0;i<that.dataDetailMPS.Lists.length;i++){
                            if(that.dataDetailMPS.Lists[i].out_flag == 1){
                                that.btn.check_qty = false
                                that.btn.scrap_qty = false
                                that.btn.man_hour = false
                                that.btn.remark = false
                            } else {
                                if(that.dataDetailMPS.Lists[i].rights == '1'){
                                    that.btn.check_qty = true
                                    if (that.$limits.authority('plv4', 42,1) == 1){
                                        that.btn.scrap_qty = true
                                    } else {
                                        that.btn.scrap_qty = false
                                    }
                                    that.btn.man_hour = true
                                    that.btn.remark = true
                                } else {
                                    that.btn.check_qty = false
                                    that.btn.scrap_qty = false
                                    that.btn.man_hour = false
                                    that.btn.remark = false
                                }
                            }
                        }*!/
				}
			});*/
            },
            beforedatachange(row) {
                let that = this;
                let index = row.$index;
                that.GHegeQty = that.dataDetailMPS.Lists[index].check_qty;
                that.GFanxiuQty = that.dataDetailMPS.Lists[index].scrap_qty;
            },
            datachange(row) {
                let that = this;
                let HegeQty;
                let BaofeiQty;
                that.getIssRemainQty();
                let index = row.$index;
                HegeQty = that.dataDetailMPS.Lists[index].check_qty;
                BaofeiQty = that.dataDetailMPS.Lists[index].scrap_qty;
                if (that.GHegeQty != HegeQty || that.GFanxiuQty != BaofeiQty) {
                    let total = parseInt(HegeQty) + parseInt(BaofeiQty);
                    let n = that.getBiaoZhunHour(
                        that.dataDetailMPS.Head.part_id,
                        that.dataDetailMPS.Lists[index].routing_id,
                        that.dataDetailMPS.Lists[index].routing_sequence_no,
                        that.dataDetailMPS.Lists[index].workcenter_code,
                        total,
                        index
                    );
                }
                   
            },
            getBiaoZhunHour(pid, rid, rno, wcode, total, index) {
                let that = this;
                let parm = {
                    part_id: pid,
                    routing_id: rid,
                    routing_sequence_no: rno,
                    workcenter_code: wcode
                };
                that.$http.urlpost('/Pro/SO/GetBiaoZhunHour', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetailMPS.Lists[index].man_hour = total * res.DataContent.DataList;
                    }
                });
            },
            getIssRemainQty() {
                let that = this;
                let parm = {
                    Code: that.dataDetailMPS.Head.so_code
                };
                that.$http.urlpost('/Pro/SO/GetIssRemainQty', parm, function (res) {
                    if (res.Success == 1) {
                        that.IssRemainQty = res.DataContent.DataList;
                        that.setValue();
                    }
                });
            },
            setValue() {
                let that = this;
                let PriorReportQty = ''; //上道的界面合格数
                let PriorLeiJiReportQty = ''; //上道的累计合格数
                let CurrentLeiJiReportQty = ''; //本道的累计合格数
                let CurrentLeiJiScrapQty = ''; //本道的累计报废数
                let SoPlanQty = that.dataDetailMPS.Head.plan_finish_qty; //计划数
                let CurrentJMReportQty = ''; //本道的界面合格数
                let CurrentJMScrapQty = ''; //本道界面报废数
                let CurrentMaxHui = ''; //本道剩余汇报数
                for (let i = 0; i < that.dataDetailMPS.Lists.length; i++) {
                    PriorReportQty = 0; //上道的界面合格数
                    PriorLeiJiReportQty = 0; //上道的累计合格数
                    CurrentLeiJiReportQty = 0; //本道的累计合格数
                    CurrentLeiJiScrapQty = 0; //本道的累计报废数
                    CurrentJMScrapQty = 0; //本道的界面报废数
                    CurrentMaxHui = 0; //本道剩余汇报数
                    if (i == 0) {
                        // 第一道工序
                        PriorReportQty = 0; //上道的界面合格数
                        PriorLeiJiReportQty = SoPlanQty; //上道的累计合格数
                    } else {
                        PriorReportQty = that.dataDetailMPS.Lists[i - 1].check_qty;
                        PriorLeiJiReportQty = that.dataDetailMPS.Lists[i - 1].hgqty;
                    }
                    if (i == 0) {
                        CurrentLeiJiReportQty = that.dataDetailMPS.Lists[i].hgqty;
                        CurrentLeiJiScrapQty = that.dataDetailMPS.Lists[i].bfqty;
                        CurrentJMReportQty = that.dataDetailMPS.Lists[i].check_qty;
                        CurrentJMScrapQty = that.dataDetailMPS.Lists[i].scrap_qty;
                        that.dataDetailMPS.Lists[i].remain_report_qty =
                            parseFloat(PriorReportQty) + parseFloat(PriorLeiJiReportQty) - parseFloat(CurrentLeiJiReportQty) - parseFloat(CurrentLeiJiScrapQty);
                        CurrentMaxHui = parseFloat(PriorReportQty) + parseFloat(PriorLeiJiReportQty) - parseFloat(CurrentLeiJiReportQty) - parseFloat(CurrentLeiJiScrapQty);
                        if (parseFloat(CurrentJMScrapQty) + parseFloat(CurrentJMReportQty) > parseFloat(CurrentMaxHui)) {
                            that.dataDetailMPS.Lists[i].jiaoyan = '报废数+合格数不能大于剩余汇报数';
                        } else {
                            that.dataDetailMPS.Lists[i].jiaoyan = '';
                        }
                    } else {
                        if (that.dataDetailMPS.Lists[i - 1].out_flag == 1 && that.dataDetailMPS.Lists[i].out_flag != 1) {
                            CurrentJMReportQty = that.dataDetailMPS.Lists[i].check_qty;
                            CurrentJMScrapQty = that.dataDetailMPS.Lists[i].scrap_qty;
                            CurrentMaxHui = that.dataDetailMPS.Lists[i].remain_report_qty;
                            let TCurrentLeiJiReportQty = that.dataDetailMPS.Lists[i].hgqty;
                            let TCurrentLeiJiScrapQty = that.dataDetailMPS.Lists[i].bfqty;
                            let TPriorReportQty = that.dataDetailMPS.Lists[i - 1].check_qty;
                            let TPriorLeiJiReportQty = that.dataDetailMPS.Lists[i - 1].hgqty;
                            let TCurrentMaxHui =
                                parseFloat(TPriorReportQty) + parseFloat(TPriorLeiJiReportQty) - parseFloat(TCurrentLeiJiReportQty) - parseFloat(TCurrentLeiJiScrapQty);
                            that.dataDetailMPS.Lists[i].remain_report_qty = TCurrentMaxHui;
                            if (parseFloat(CurrentJMScrapQty) + parseFloat(CurrentJMReportQty) > parseFloat(CurrentMaxHui)) {
                                that.dataDetailMPS.Lists[i].jiaoyan = '报废数+合格数不能大于剩余汇报数';
                            } else {
                                that.dataDetailMPS.Lists[i].jiaoyan = '';
                            }
                        } else {
                            CurrentLeiJiReportQty = that.dataDetailMPS.Lists[i].hgqty;
                            CurrentLeiJiScrapQty = that.dataDetailMPS.Lists[i].bfqty;
                            CurrentJMReportQty = that.dataDetailMPS.Lists[i].check_qty;
                            CurrentJMScrapQty = that.dataDetailMPS.Lists[i].scrap_qty;
                            if (that.dataDetailMPS.Lists[i].out_flag == 1) {
                                that.dataDetailMPS.Lists[i].remain_report_qty =
                                    parseFloat(PriorReportQty) +
                                    parseFloat(PriorLeiJiReportQty) -
                                    parseFloat(CurrentLeiJiReportQty) -
                                    parseFloat(CurrentLeiJiScrapQty) -
                                    parseFloat(that.IssRemainQty);
                            } else {
                                that.dataDetailMPS.Lists[i].remain_report_qty =
                                    parseFloat(PriorReportQty) + parseFloat(PriorLeiJiReportQty) - parseFloat(CurrentLeiJiReportQty) - parseFloat(CurrentLeiJiScrapQty);
                            }
                            CurrentMaxHui = parseFloat(PriorReportQty) + parseFloat(PriorLeiJiReportQty) - parseFloat(CurrentLeiJiReportQty) - parseFloat(CurrentLeiJiScrapQty);
                            if (parseFloat(CurrentJMScrapQty) + parseFloat(CurrentJMReportQty) > parseFloat(CurrentMaxHui)) {
                                that.dataDetailMPS.Lists[i].jiaoyan = '报废数+合格数不能大于剩余汇报数';
                            } else {
                                that.dataDetailMPS.Lists[i].jiaoyan = '';
                            }
                        }
                    }
                }
            },
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            so_code: that.dataDetail.Head.so_code,
                            so_status: that.dataDetail.Head.so_status,
                            concurrent_time: that.dataDetail.Head.concurrent_time
                        };
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Pro/SO/DelSoBill', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message({
                                    duration: 2000,
                                    showClose: true,
                                    message: that.$processdata.explainCallbackMsg(res.Msg),
                                    type: 'success'
                                })
                                that.getView();
                                that.confirmAdd();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            handleSelectionChangeDetail(val) {
                let that = this;
                that.selectDataDetail = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataDetail.push(val[i]);
                }
                that.btnauthority();
            },
            tableRowClassNameDetail({ row, rowIndex }) {
                row.index = rowIndex;
            },
            handleSelectionChangeDetail2(val) {
                let that = this;
                that.selectDataDetail2 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataDetail2.push(val[i]);
                }
                that.btnauthority();
            },
            tableRowClassNameDetail2({ row, rowIndex }) {
                row.index = rowIndex;
            },
            delLists(data) {
                let that = this;
                if (data.row.exclusively_id == '') {
                    that.dataDetail.Lists.splice(data.$index, 1);
                } else {
                    that.dataDetail.Lists.splice(data.$index, 1);
                    let parm = {
                        so_code: that.dataDetail.Head.so_code,
                        exclusively_id: data.row.exclusively_id,
                        concurrent_time: that.dataDetail.Head.concurrent_time,
                        LangType:that.$processdata.getLang(),
                    };
                    that.$http.urlpost('/Pro/SO/DelSoRouting', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message({
                                duration: 2000,
                                showClose: true,
                                message: that.$processdata.explainCallbackMsg(res.Msg),
                                type: 'success'
                            })
                        }
                        that.getDetail(that.code);
                    });
                }
            },
            handleSelectionChangeDetailMaster(val) {
                let that = this;
                that.selectDataDetailMaster = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataDetailMaster.push(val[i]);
                }
                that.btnauthority();
            },
            delMaster(data) {
                let that = this;
                if (data.row.exclusively_id == '') {
                    that.dataDetail.MasterLists.splice(data.$index, 1);
                } else {
                    that.dataDetail.MasterLists.splice(data.$index, 1);
                    let parm = {
                        so_code: that.dataDetail.Head.row.so_code,
                        exclusively_id: data.row.exclusively_id,
                        concurrent_time: that.dataDetail.Head.concurrent_time,
                        part_id: data.row.part_id,
                        part_code: data.row.part_code,
                        part_version: data.row.part_version
                    };
                    that.$http.urlpost('/Pro/SO/DelSoMaster', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message({
                                duration: 2000,
                                showClose: true,
                                message: that.$processdata.explainCallbackMsg(res.Msg),
                                type: 'success'
                            })
                            that.getDetail(that.code);
                        }
                    });
                }
            },
            handleSelectionChangeDetailAssist(val) {
                let that = this;
                that.selectDataDetailAssist = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataDetailAssist.push(val[i]);
                }
                that.btnauthority();
            },
            delAssist(data) {
                let that = this;
                console.log(data)
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        if (data.row.exclusively_id == '') {
                            that.dataDetail.AssistLists.splice(data.$index, 1);
                        } else {
                            that.dataDetail.AssistLists.splice(data.$index, 1);
                            let parm = {
                                so_code: that.dataDetail.Head.so_code,
                                exclusively_id: data.row.exclusively_id,
                                concurrent_time: that.dataDetail.Head.concurrent_time,
                                part_id: data.row.part_id,
                                part_code: data.row.part_code,
                                part_version: data.row.part_version,
                                LangType:that.$processdata.getLang()
                            };
                            that.$http.urlpost('/Pro/SO/DelSoAssist', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message({
                                        duration: 2000,
                                        showClose: true,
                                        message: that.$processdata.explainCallbackMsg(res.Msg),
                                        type: 'success'
                                    })
                                    that.getDetail(that.code);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            handleSelectionChangeDetailMPS(val) {
                let that = this;
            },
            // 执行汇报保存
            saveProSoReport(value) {
                let that = this;
                that.dataDetailMPS.Head.iscontinue = value;
                let parm = {
                    head: that.dataDetailMPS.Head,
                    Lists: that.dataDetailMPS.Lists,
                    LangType:that.$processdata.getLang()
                };
                that.$http.urlpost('/Pro/SO/SaveProSoReport', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getMPSBillInfo();
                    } else if (res.Success > 1) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.saveProSoReport(res.Success);
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            // 暂停
            suspend() {
                let that = this;
                let parm = {};
                let arr = [];
                if (that.SelectIndex == 2) {
                    for (let i = 0; i < that.selectData2.length; i++) {
                        arr = [
                            ...arr,
                            {
                                so_code: that.selectData2[i].SO_CODE
                            }
                        ];
                    }
                } else if (that.SelectIndex == 3) {
                    for (let i = 0; i < that.selectData3.length; i++) {
                        arr = [
                            ...arr,
                            {
                                so_code: that.selectData3[i].SO_CODE
                            }
                        ];
                    }
                }
                parm = {
                    SoList: arr
                };
                that.$http.urlpost('/Pro/SO/SOSuspend', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getView();
                    }
                });
            },
            // 恢复
            recover() {
                let that = this;
                let parm = {};
                let arr = [];
                if (that.SelectIndex == 2) {
                    for (let i = 0; i < that.selectData2.length; i++) {
                        arr = [
                            ...arr,
                            {
                                so_code: that.selectData2[i].SO_CODE
                            }
                        ];
                    }
                } else if (that.SelectIndex == 3) {
                    for (let i = 0; i < that.selectData3.length; i++) {
                        arr = [
                            ...arr,
                            {
                                so_code: that.selectData3[i].SO_CODE
                            }
                        ];
                    }
                }
                parm = {
                    SoList: arr
                };
                that.$http.urlpost('/Pro/SO/SORecover', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getView();
                    }
                });
            },
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[1488]')//'下达';
                } else if (val == 2) {
                    return that.$t('getapi[3073]')//'开工';
                } else if (val == 3) {
                    return that.$t('getapi[441]')//'关闭';
                } else if (val == 4) {
                    return that.$t('getapi[6]')//'取消';
                } else {
                    return '';
                }
            },
            //获取物料
            selectpart() {
                let that = this;
                that.$refs.part.clearInput(true);
            },
            getpart(data) {
                let that = this;
                console.log(data);
                that.dataDetail.Head.item_code = data.item_code;
                that.dataDetail.Head.part_code = data.part_code;
                that.dataDetail.Head.part_id = data.exclusively_id;
                that.dataDetail.Head.part_version = data.part_version;
                that.dataDetail.Head.produce_leadtime = data.produce_leadtime;
                that.dataDetail.Head.routing_version = data.routing_version;
                that.dataDetail.Head.trace = data.trace;
                that.dataDetail.Head.move_direction = data.move_direction;
                that.dataDetail.Head.routing_remark = data.remark;
                that.dataDetail.Head.direct_stuff_move_flag = data.move_direction == null ? '0' : '1';
                let parm = {
                    base_so_code:that.base_so_code,
                    so_code: that.dataDetail.Head.so_code,
                    part_id: data.exclusively_id,
                    plan_finish_qty: that.dataDetail.Head.plan_finish_qty,
                };
                that.getListByPartId(parm);
                that.getSignList(data.exclusively_id);
            },
            getListByPartId(parm) {
                let that = this;
                that.loadingDetail = true
                that.$http.urlpost('/Pro/SO/GetSORoutingListByPartId', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.Lists = res.DataContent.Lists;
                        that.dataDetail.MasterLists = res.DataContent.MasterLists;
                    }
                    that.loadingDetail = false
                });
                console.log(JSON.stringify(that.dataDetail.Lists));
                that.updateArr();
            },
            // 获取配置批号
            getSignList(id) {
                let that = this;
                let parm = {
                    Id: id
                };
                that.$http.urlpost('/Pro/SR/GetSrSignsByPartId', parm, function (res) {
                    if (res.Success == 1) {
                        that.SignList = res.DataContent.DataList;
                    }
                });
            },
            //获取工作中心
            selectworkcenter(row) {
                let that = this;
                if (row != '') {
                    that.rowindex_workcenter = row.$index;
                    that.oneormore_workcenter = 2;
                } else {
                    that.oneormore_workcenter = 1;
                }
                that.$refs.workcenter.clearInput(true);
            },
            getworkcenter(data) {
                let that = this;
                console.log(data);
                if (that.oneormore_workcenter == 1) {
                    that.dataDetail.Lists = [
                        ...that.dataDetail.Lists,
                        {
                            exclusively_id: 0,
                            so_code: '',
                            routing_sequence_no: '',
                            routing_id: '',
                            workproc_name: '',
                            routing_desc: '',
                            workcenter_code: data.workcenter_code,
                            workcenter_name: data.workcenter_name,
                            manhour_unit: data.queue_time_unit,
                            ready_manhour: '',
                            running_manhour: '',
                            queue_manhour: data.queue_time,
                            man_power: '',
                            min_transfer_qty: '',
                            start_produce_time: '',
                            finish_produce_time: '',
                            create_person: '',
                            create_time: '',
                            modify_person: '',
                            modify_time: '',
                            cd_code: data.work_calendar_code,
                            finish_qty: 0,
                            actual_finish_time: null,
                            remark: '',
                            routing_direction: 0,
                            routing_index: 0,
                            routing_relation_no: '',
                            report_s_date: '',
                            s_flag: 0,
                            s_flag_name: '',
                            report_s_person: '',
                            exception_flag: 0,
                            exception_flag_name: '',
                            pos_qty: 0,
                            check_status: 0,
                            check_status_name: null,
                            qualify_qty: 0,
                            scrap_qty: 0,
                            review_qty_sum: 0,
                            out_flag: data.out_flag,
                            backsecond_flag: 0,
                            apply_check_person: null,
                            apply_check_time: null,
                            check_person: null,
                            check_time: null,
                            end_flag: 0,
                            next_workcenter_code: null,
                            key_flag: 0,
                            start_time: '',
                            end_time: '',
                            lock_r_code: '',
                            ready_material_time: '',
                            wait_time: '',
                            isedit:1,
                            isdel:0,
                            period_flag:0,
                            period_hour:0,
                            group_name: '',
                            r_code: '',
                            workproc_id:data.workproc_id,
                        }
                    ];
                } else {
                    that.dataDetail.Lists[that.rowindex_workcenter].workcenter_code = data.workcenter_code;
                    that.dataDetail.Lists[that.rowindex_workcenter].workcenter_name = data.workcenter_name;
                    that.dataDetail.Lists[that.rowindex_workcenter].manhour_unit = data.queue_time_unit;
                    that.dataDetail.Lists[that.rowindex_workcenter].queue_manhour = data.queue_time;
                    that.dataDetail.Lists[that.rowindex_workcenter].cd_code = data.work_calendar_code;
                    that.dataDetail.Lists[that.rowindex_workcenter].out_flag = data.out_flag;
                    that.dataDetail.Lists[that.rowindex_workcenter].workproc_id = data.workproc_id;
                    that.dataDetail.Lists[that.rowindex_workcenter].isedit = 1;
                }
            },
            selectGroupName(row){
                let that = this;
                that.rowindex_workcenter = row.$index
                that.$refs.groupname.clearInput(true);
            },
            getGroupName(val){
                let that = this;
                that.dataDetail.Lists[this.rowindex_workcenter].r_code = ''
                that.dataDetail.Lists[this.rowindex_workcenter].group_name = val.group_name
            },
            selectRCode(row){
                let that = this;
                that.rowindex_workcenter = row.$index
                that.$refs.rcode.clearInput(true);
            },
            getRCode(val){
                let that = this;
                console.log(val)
                that.dataDetail.Lists[this.rowindex_workcenter].group_name = val.group_name
                that.dataDetail.Lists[this.rowindex_workcenter].r_code = val.r_code
            },
            //获取工序
            selectroute(row) {
                let that = this;
                that.rowindex_route = row.$index;
                that.$refs.route.clearInput(true);
            },
            getroute(data) {
                let that = this;
                console.log(data);
                that.dataDetail.Lists[that.rowindex_route].workproc_name = data.workproc_name;
                that.dataDetail.Lists[that.rowindex_route].workproc_code = data.workproc_code;
                that.dataDetail.Lists[that.rowindex_route].routing_id = data.exclusively_id;
                that.dataDetail.Lists[that.rowindex_route].isedit = 1;
            },
            //获取物料-附加料表
            selectpartassist(row) {
                let that = this;
                if (row != '') {
                    that.rowindex_partassist = row.$index;
                    that.oneormore_partassist = 2;
                } else {
                    that.oneormore_partassist = 1;
                }
                let param = {
                    so_code: that.dataDetail.Head.so_code,
                    part_id: that.dataDetail.Head.part_id
                };
                that.$refs.partassist.clearInput(true, param);
            },
            getpartassist(data) {
                let that = this;
                console.log(data);
                let arr1 = [];
                let arr2 = [];
                for (let i = 0; i < that.dataDetail.MasterLists.length; i++) {
                    arr1 = [
                        ...arr1,
                        {
                            part_id: that.dataDetail.MasterLists[i].part_id
                        }
                    ];
                }
                for (let i = 0; i < that.dataDetail.AssistLists.length; i++) {
                    arr2 = [
                        ...arr2,
                        {
                            part_code: that.dataDetail.AssistLists[i].part_code
                        }
                    ];
                }
                let parm = {
                    part_id: that.dataDetail.Head.part_id,
                    sel_part_code: data.part_code,
                    sel_part_id: data.exclusively_id,
                    sel_part_version: data.part_version,
                    MasterLists: arr1,
                    AssistLists: arr2,
                    LangType: that.$processdata.getLang(),
                };
                that.getStuffPart(parm,'');
            },
            getStuffPart(parm,qty) {
                let that = this;
                that.$http.urlpost('/Pro/SO/GetSelSOStuffPartDataList', parm, function (res) {
                    if (res.Success == 1) {
                        let data = res.DataContent.DataList[0];
                        that.routing_sequence_noArr = [];
                        let arr = [];
                        for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                            arr = [
                                ...arr,
                                {
                                    val: that.dataDetail.Lists[i].routing_sequence_no
                                }
                            ];
                        }
                        for (var i = 0; i < arr.length; i++) {
                            for (var j = i + 1; j < arr.length; j++) {
                                if (arr[i] == arr[j]) {
                                    arr.splice(j, 1);
                                    j--;
                                }
                            }
                        }
                        that.routing_sequence_noArr = arr;
                        let routing_sequence_no = 0;
                        for (let i = 0; i < arr.length; i++) {
                            if (i == 0) {
                                routing_sequence_no = arr[i].val;
                            } else {
                                if (routing_sequence_no > arr[i].val) {
                                    routing_sequence_no = arr[i].val;
                                }
                            }
                        }
                        if (that.oneormore_partassist == 1) {
                            that.dataDetail.AssistLists = [
                                ...that.dataDetail.AssistLists,
                                {
                                    exclusively_id: '',
                                    so_code: '',
                                    part_id: data.exclusively_id,
                                    part_code: data.part_code,
                                    part_version: data.part_version,
                                    part_master_unit: data.part_master_unit,
                                    part_assist_unit: data.part_assist_unit,
                                    part_name: data.part_name,
                                    part_model: data.part_model,
                                    part_spec: data.part_spec,
                                    part_stuff: data.part_stuff,
                                    std_stuff_qty: '',
                                    std_bom_qty: '',
                                    bomqty: '',
                                    bomhansun: '',
                                    discard_rate: '',
                                    so_stuff_qty: qty,
                                    assembly_flag: '',
                                    so_stuff_status: '',
                                    so_stuff_status_name: '',
                                    total_issue_qty: data.total_issue_qty,
                                    assist_total_issue_qty: data.assist_total_issue_qty,
                                    total_return_qty: data.total_return_qty,
                                    assist_total_return_qty: data.assist_total_return_qty,
                                    create_person: '',
                                    create_time: '',
                                    modify_person: '',
                                    modify_time: '',
                                    remark: '',
                                    master_assist_flag: '',
                                    routing_sequence_no: routing_sequence_no,
                                    routing_sequence_no_read: ''
                                }
                            ];
                        } else {
                            that.dataDetail.AssistLists[that.rowindex_partassist].part_id = data.exclusively_id;
                            that.dataDetail.AssistLists[that.rowindex_partassist].part_code = data.part_code;
                            that.dataDetail.AssistLists[that.rowindex_partassist].part_version = data.part_version;
                            that.dataDetail.AssistLists[that.rowindex_partassist].part_name= data.part_name;
                            that.dataDetail.AssistLists[that.rowindex_partassist].part_model= data.part_model;
                            that.dataDetail.AssistLists[that.rowindex_partassist].part_spec= data.part_spec;
                            that.dataDetail.AssistLists[that.rowindex_partassist].part_stuff= data.part_stuff;
                            that.dataDetail.AssistLists[that.rowindex_partassist].part_master_unit = data.part_master_unit;
                            that.dataDetail.AssistLists[that.rowindex_partassist].part_assist_unit = data.part_assist_unit;
                            that.dataDetail.AssistLists[that.rowindex_partassist].total_issue_qty = data.total_issue_qty;
                            that.dataDetail.AssistLists[that.rowindex_partassist].assist_total_issue_qty = data.assist_total_issue_qty;
                            that.dataDetail.AssistLists[that.rowindex_partassist].total_return_qty = data.total_return_qty;
                            that.dataDetail.AssistLists[that.rowindex_partassist].assist_total_return_qty = data.assist_total_return_qty;
                            that.dataDetail.AssistLists[that.rowindex_partassist].routing_sequence_no = routing_sequence_no;
                        }
                    }
                });
            },
            // 下达
            billRelease() {
                let that = this;
                let parm = {
                    so_code: that.dataDetail.Head.so_code,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                    so_status: that.dataDetail.Head.so_status,
                    part_code: that.dataDetail.Head.part_code,
                    part_version: that.dataDetail.Head.part_version,
                    part_id: that.dataDetail.Head.part_id,
                    item_code: that.dataDetail.Head.item_code,
                    schedule_no: that.dataDetail.Head.schedule_no,
                    relation_sr_code: that.dataDetail.Head.relation_sr_code,
                    plan_finish_qty: that.dataDetail.Head.plan_finish_qty,
                    new_flag: that.dataDetail.Head.new_flag,
                    so_type: that.dataDetail.Head.so_type,
                    iss_self_bad_flag: that.dataDetail.Head.iss_self_bad_flag,
                    workcenter_code: that.dataDetail.Head.workcenter_code,
                    LangType: that.$processdata.getLang(),
                };
                that.$http.urlpost('/Pro/SO/SoBillRelease', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getDetail(that.code);
                    }
                });
            },
            // 取消
            soBillCancel() {
                let that = this;
                that.reason = '';
                that.visSoBillCancel = true;
            },
            confirmSoBillCancel() {
                let that = this;
                let parm = {
                    so_code: that.dataDetail.Head.so_code,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                    so_status: that.dataDetail.Head.so_status,
                    reason: that.reason,
                    LangType: that.$processdata.getLang(),
                };
                that.$http.urlpost('/Pro/SO/SoBillCancel', parm, function (res) {
                    if (res.Success == 1) {
                        that.visSoBillCancel = false;
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getDetail(that.code);
                    }
                });
            },
            //关闭
            billClose() {
                let that = this;
                that.reasonclose = '';
                that.visClose = true;
            },
            //确认关闭
            confirmBillClose(val) {
                let that = this;
                let parm = {
                    so_code: that.dataDetail.Head.so_code,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                    so_status: that.dataDetail.Head.so_status,
                    reason: that.reasonclose,
                    part_code: that.dataDetail.Head.part_code,
                    part_version: that.dataDetail.Head.part_version,
                    item_code: that.dataDetail.Head.item_code,
                    iscontinue: val,
                    LangType: that.$processdata.getLang(),
                };
                that.$http.urlpost('/Pro/SO/SoBillClose', parm, function (res) {
                    if (res.Success == 1) {
                        that.visClose = false;
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.getDetail(that.code);
                    } else if (res.Success > 1) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.confirmBillClose(res.Success);
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            //切换工艺版本
            changeRoutVer() {
                let that = this;
                that.visChangeRoutVer = true;
                let parm = {
                    so_code: that.dataDetail.Head.so_code,
                    part_code: that.dataDetail.Head.part_code,
                    part_version: that.dataDetail.Head.part_version,
                    routing_version: that.dataDetail.Head.routing_version
                };
                that.$http.urlpost('/Pro/SO/GetChangeRoutVerList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetailChangeRoutVer = res.DataContent;
                    }
                });
            },
            confirmChangeRoutVer() {
                let that = this;
                let parm = {
                    so_code: that.dataDetailChangeRoutVer.Head.so_code,
                    routing_version: that.dataDetailChangeRoutVer.Head.routing_version
                };
                that.$http.urlpost('/Pro/SO/SoBillChanageVer', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message({
                            duration: 2000,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })
                        that.visChangeRoutVer = false;
                        that.getDetail(that.code);
                    }
                });
            },
            // 批量替换物料
            batchReplacePart() {
                let that = this;
                let parm = {
                    so_code: that.selectDataDetail2[0].so_code,
                    part_id: that.selectDataDetail2[0].part_id
                };
                that.$http.urlpost('/Pro/SO/SOCheckExistInStuff', parm, function (res) {
                    if (res.Success == 1) {
                        /*that.$message({
                            duration: 0,
                            showClose: true,
                            message: that.$processdata.explainCallbackMsg(res.Msg),
                            type: 'success'
                        })*/
                        that.visReplacePart = true;
                        that.replace_part_code = that.selectDataDetail2[0].part_code;
                        that.replace_part_version = that.selectDataDetail2[0].part_version;
                        that.replace_part_id = that.selectDataDetail2[0].part_id;
                        that.replace_so_code = that.selectDataDetail2[0].so_code;
                        that.replace_sel_part_code = ''
                        that.replace_sel_part_version = ''
                        that.replace_sel_part_id = ''
                    }
                });
            },
            //更新底层码
            updateLLC(){
                let that = this
                let parm = {

                }
                that.$http.urlpost('/Basic/UpdateLLC', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            getPartReplaceSOList() {
                let that = this;
                let parm = {
                    part_id: that.replace_part_id,
                    sel_part_id: that.replace_sel_part_id
                };
                that.$http.urlpost('/Pro/SO/GetPartReplaceSOList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetailReplace = res.DataContent.Lists;
                    }
                });
            },
            //获取替换物料
            selectreplacepart() {
                let that = this;
                let param = {
                    so_code: that.selectDataDetail2[0].so_code,
                    part_id: that.selectDataDetail2[0].part_id
                };
                that.$refs.replacepart.clearInput(true, param);
            },
            getreplacepart(data) {
                let that = this;
                console.log(data);
                that.replace_sel_part_code = data.part_code;
                that.replace_sel_part_version = data.part_version;
                that.replace_sel_part_id = data.part_ID;
                that.getPartReplaceSOList();
            },
            // 全选
            checkAll(val) {
                let that = this;
                console.log(val);
                if (val == true) {
                    for (let i = 0; i < that.dataDetailReplace.length; i++) {
                        that.dataDetailReplace[i].applicationto = '1';
                    }
                } else {
                    for (let i = 0; i < that.dataDetailReplace.length; i++) {
                        that.dataDetailReplace[i].applicationto = '0';
                    }
                }
            },
            // 筛选
            filter() {
                let that = this;
                let parm = {
                    part_id: that.replace_part_id,
                    sel_part_id: that.replace_sel_part_id,
                    so_code: that.filter_so_code,
                    item_code: that.filter_item_code
                };
                that.$http.urlpost('/Pro/SO/GetSearchReplaceDataList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetailReplace = res.DataContent.Lists;
                    }
                });
            },
            confirmBatchReplacePart() {
                let that = this;
                let num=0
                for(let i=0;i<that.dataDetailReplace.length;i++){
                    if(that.dataDetailReplace[i].applicationto == true){
                        num += 1
                    }
                }
                this.$confirm(num + that.$t('getapi[13007]'), that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            so_code: that.replace_so_code,
                            part_id: that.replace_part_id,
                            part_code: that.replace_part_code,
                            sel_part_id: that.replace_sel_part_id,
                            Lists: that.dataDetailReplace,
                            LangType: that.$processdata.getLang(),
                        };
                        that.btn.confirmBatchReplacePart = false
                        that.$http.urlpost('/Pro/SO/SOAppToOtherSaveData', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message({
                                    duration: 2000,
                                    showClose: true,
                                    message: that.$processdata.explainCallbackMsg(res.Msg),
                                    type: 'success'
                                })
                                that.visReplacePart = false;
                            }
                            that.btn.confirmBatchReplacePart = true
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 去掉直接流转勾选 清空流转方向
            clearMoveDirection(val) {
                let that = this;
                console.log(val);
                if (val == 0) {
                    that.dataDetail.Head.move_direction = '';
                }
            },
            // 解析检查状态
            expCStatus(val,qty) {
                let that = this
                if (val == 0 && qty>0) {
                    return that.$t('getapi[1461]')//'合格';
                } else if(val == 0){
                    return that.$t('getapi[8919]')//'待申请报检';
                } else if (val == 1) {
                    return that.$t('getapi[8920]')//'申请报检';
                } else if (val == 2) {
                    return that.$t('getapi[1749]')//'已检';
                } else {
                    return '';
                }
            },
            expSoStuffStatus(val) {
                let that = this
                if (val == 1) {
                    return that.$t('getapi[4349]')//'正常';
                } else if (val == 2) {
                    return that.$t('getapi[4350]')//'发料完毕';
                } else if (val == 3) {
                    return that.$t('getapi[4351]')//'超额';
                } else {
                    return '';
                }
            },
            //根据输入的计划完工数量计算主料表SO用量
            getSoStuffQty(val) {
                let that = this;
                let parm = {
                    plan_finish_qty: that.dataDetail.Head.plan_finish_qty,
                    list: that.dataDetail.MasterLists
                }
                that.loadingDetail = true
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pro/SO/GetSoStuffQty', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.MasterLists = res.DataContent.list;
                    }
                    that.loadingDetail = false
                    loadingInstance.close();
                    that.$refs.SetBtn.SetOneBtnEnable('save', true)
                });
                /*let token = that.userData.token;
                for (let i = 0; i < that.dataDetail.MasterLists.length; i++) {
                    let parm = {
                        plan_finish_qty: that.dataDetail.Head.plan_finish_qty,
                        part_code: that.dataDetail.Head.part_code,
                        part_version: that.dataDetail.Head.part_version,
                        std_bom_qty: that.dataDetail.MasterLists[i].std_bom_qty
                    };
                    that.dataDetail.MasterLists[i].bomqty = that.$processdata.mathRound4(that.dataDetail.MasterLists[i].std_stuff_qty * that.dataDetail.Head.plan_finish_qty);
                    that.dataDetail.MasterLists[i].bomhansun = that.$processdata.mathRound4(that.dataDetail.MasterLists[i].std_bom_qty * that.dataDetail.Head.plan_finish_qty);
                    that.$http.urlpost('/Pro/SO/GetSoStuffQty', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataDetail.MasterLists[i].so_stuff_qty = res.DataContent;
                        }
                    });
                    /!*$.ajax({
                        url: Common.Url + 'Pro/SO/GetSoStuffQty?token=' + token,
                        type: 'post',
                        async: false,
                        data: JSON.stringify(parm),
                        contentType: 'application/json',
                        success: function (res) {
                            if (res.Success == 1) {
                                that.dataDetail.MasterLists[i].so_stuff_qty = res.DataContent;
                            }
                        }
                    });*!/
                }*/
            },
            // 校验工序号
            checkrouting_sequence_no(row) {
                let that = this;
                let index = row.$index;
                let routing_sequence_no=0;
                that.dataDetail.Lists[index].isedit = 1;
                if(that.dataDetail.Head.so_status==1 || that.dataDetail.Head.so_status==2){
                    if (that.dataDetail.Lists.length > 1) {
                        for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                            if(that.dataDetail.Lists[i].isdel>0 && i != index){                                
                                if(routing_sequence_no<that.dataDetail.Lists[i].routing_sequence_no){
                                    routing_sequence_no=that.dataDetail.Lists[i].routing_sequence_no;
                                }
                            }
                        }
                    }
                    if(that.dataDetail.Lists[index].routing_sequence_no<routing_sequence_no){
                        that.dataDetail.Lists[index].routing_sequence_no = '';
                        that.$message.warning(that.$t('getapi[8848]')+routing_sequence_no);//'该工序号必须大于'
                    }
                }

                

                if (that.dataDetail.Lists.length > 1) {
                    for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                        if (that.dataDetail.Lists[i].routing_sequence_no == that.dataDetail.Lists[index].routing_sequence_no && i != index) {
                            that.dataDetail.Lists[index].routing_sequence_no = '';
                        }
                    }
                }
                //that.updateArr()
            },
            // 更新工序号数组
            updateArr() {
                let that = this;
                that.arrroutingsequenceno = [];
                for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                    if (that.dataDetail.Lists[i].routing_sequence_no != '') {
                        that.arrroutingsequenceno = [
                            ...that.arrroutingsequenceno,
                            {
                                Code: that.dataDetail.Lists[i].routing_sequence_no
                            }
                        ];
                    }
                }
            },
            ChargestuffQty(row){
                //表示该行记录被修改过
                row.row.isedit=1;
            },
            ChargeRouting(row){
                //表示该行记录被修改过
                row.row.isedit=1;
            },
            // 校验是否可以修改工序号
            isCanChange(type, row) {
                let that = this;
                console.log(row);
                let index = ''
                if (type == 1) {
                    index = row.$rowIndex;
                } else {
                    index = row.$index
                }
                let routing_sequence_no = '';
                let data = JSON.parse(that.oldDataDetail);
                if (type == 1) {
                    routing_sequence_no = data.MasterLists[index].routing_sequence_no;
                } else if (type == 2) {
                    routing_sequence_no = data.AssistLists[index].routing_sequence_no;
                }
                //表示该行记录被修改过
                row.row.isedit=1;
                let parm = {
                    so_code: that.dataDetail.Head.so_code,
                    exclusively_id: row.row.exclusively_id,
                    routing_sequence_no: row.row.routing_sequence_no
                };
                that.$http.urlpost('/Pro/SO/CheckRoutingSequenceNo', parm, function (res) {
                    if (res.Success == 1) {
                        if (res.DataContent == '存在') {
                            if (type == 1) {
                                that.dataDetail.MasterLists[index].routing_sequence_no = routing_sequence_no;
                            } else {
                                that.dataDetail.AssistLists[index].routing_sequence_no = routing_sequence_no;
                            }
                            that.$message.warning(that.$t('getapi[8849]'));//'该物料存在发料单，禁止修改工序号'
                        }
                    }
                });
            },
            //校验日期格式
            checkDateTime(row, type) {
                let that = this
                let rexp = /^(?:19|20)[0-9][0-9]-(?:(?:0[1-9])|(?:1[0-2]))-(?:(?:[0-2][1-9])|(?:[1-3][0-1]))| (?:(?:[0-2][0-3])|(?:[0-1][0-9])):[0-5][0-9]:[0-5][0-9]$/
                let index = row.$index
                if (type == 1) {
                    console.log(!rexp.test(row.row.start_produce_time))
                    if (!rexp.test(row.row.start_produce_time)) {
                        that.$message.warning(that.$t('getapi[8850]'))//'开工时间格式填写错误,如：2022-01-01 09:12:00"'
                        that.dataDetail.Lists[index].start_produce_time = ''
                    }
                } else {
                    if (!rexp.test(row.row.finish_produce_time)) {
                        that.$message.warning(that.$t('getapi[8851]'))//'完工时间格式填写错误,如：2022-01-01 09:12:00"'
                        that.dataDetail.Lists[index].finish_produce_time = ''
                    }
                }
            },
            // 排序
            sortChange({ data, column, field, order }){
                let that = this
                //that.$processdata.sortChangeVxe(column,that.dataDetail.MasterLists)
                let data1 = data.filter((item)=>{return item[column.property] === undefined})
                let data2 = data.filter((item)=>{return item[column.property] !== undefined})
                let tmpData = []
                if(order === 'desc') {
                    tmpData =  data2.sort((a,b)=>{
                        if(typeof(a[column.property]) === 'number'){
                            return b[column.property] - a[column.property]
                        }else{
                            return b[column.property].localeCompare(a[column.property]);
                        }
                    }).concat(data1)
                }
                if(order === 'asc'){
                    tmpData =  data1.concat(data2.sort((a,b)=>{
                        if(typeof(a[column.property]) === 'number'){
                            return a[column.property] - b[column.property]
                        }else{
                            return a[column.property].localeCompare(b[column.property]);
                        }
                    }))
                }
                return tmpData;
            },
            // 附加料表复制物料获取数据
            // 粘贴
            keyPaste(e) {
                let that = this;
                if (this.$route.name == this.$options.name && this.RightSelectIndex == 2) {
                    if (e.clipboardData) {
                        var data = e.clipboardData.getData('Text');
                        if (!that.$limits.fnIsEmpty(data)) {
                            that.check(data);
                        }
                    }
                }
            },

            check(datap) {
                let that = this
                let str = JSON.stringify(datap)
                str = str.replace('"', '').replace('"', '')
                let arr = str.split("\\r\\n")
                let arrlist = []
                let arr1 = [];
                let arr2 = [];
                for (let i = 0; i < arr.length - 1; i++) {
                    if (arr[i].split('\\t').length == 2) {
                        arrlist = [...arrlist, {
                            part_code: arr[i].split('\\t')[0],
                            qty: parseFloat(arr[i].split('\\t')[1]),
                        }]
                    }
                }
                const filterUniqueByPartCode = (arr) => {
                    const map = new Map();
                    return arr.filter(item => {
                        if (!map.has(item.part_code)) {
                            map.set(item.part_code, true);
                            return true;
                        }
                        return false;
                    });
                };
                arrlist = filterUniqueByPartCode(arrlist)
                if (arrlist.length > 0) {
                    for (let i = 0; i < that.dataDetail.MasterLists.length; i++) {
                        arr1 = [
                                ...arr1,
                        {
                            part_id: that.dataDetail.MasterLists[i].part_id
                        }];
                    }
                    for (let i = 0; i < that.dataDetail.AssistLists.length; i++) {
                        arr2 = [
                            ...arr2,
                        {
                            part_code: that.dataDetail.AssistLists[i].part_code
                        }];
                    }

                    let parm = {
                        so_code: that.dataDetail.Head.so_code,
                        part_id: that.dataDetail.Head.part_id,
                        list: arrlist,
                        MasterLists: arr1,
                        AssistLists: arr2,
                        LangType:that.$processdata.getLang(),
                    }
                    that.$http.urlpost('/Pro/SO/GetAssistListsByPartCode', parm, function (res) {
                        if (res.Success == 1) {
                            console.log(res)
                            let data = res.DataContent.List
                            that.routing_sequence_noArr = [];
                            let arr = [];
                            for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                                arr = [
                                    ...arr,
                                    {
                                        val: that.dataDetail.Lists[i].routing_sequence_no
                                    }
                                ];
                            }
                            for (var i = 0; i < arr.length; i++) {
                                for (var j = i + 1; j < arr.length; j++) {
                                    if (arr[i] == arr[j]) {
                                        arr.splice(j, 1);
                                        j--;
                                    }
                                }
                            }
                            that.routing_sequence_noArr = arr;
                            let routing_sequence_no = 0;
                            for (let i = 0; i < arr.length; i++) {
                                if (i == 0) {
                                    routing_sequence_no = arr[i].val;
                                } else {
                                    if (routing_sequence_no > arr[i].val) {
                                        routing_sequence_no = arr[i].val;
                                    }
                                }
                            }
                            for(let i = 0;i<data.length;i++){
                                that.dataDetail.AssistLists = [
                                    ...that.dataDetail.AssistLists,
                                    {
                                        exclusively_id: '',
                                        so_code: '',
                                        part_id: data[i].exclusively_id,
                                        part_code: data[i].part_code,
                                        part_version: data[i].part_version,
                                        part_master_unit: data[i].part_master_unit,
                                        part_assist_unit: data[i].part_assist_unit,
                                        std_stuff_qty: '',
                                        std_bom_qty: '',
                                        bomqty: '',
                                        bomhansun: '',
                                        discard_rate: '',
                                        so_stuff_qty: data[i].number,
                                        assembly_flag: '',
                                        so_stuff_status: '',
                                        so_stuff_status_name: '',
                                        total_issue_qty: data[i].total_issue_qty,
                                        assist_total_issue_qty: data[i].assist_total_issue_qty,
                                        total_return_qty: data[i].total_return_qty,
                                        assist_total_return_qty: data[i].assist_total_return_qty,
                                        create_person: '',
                                        create_time: '',
                                        modify_person: '',
                                        modify_time: '',
                                        remark: '',
                                        master_assist_flag: '',
                                        routing_sequence_no: routing_sequence_no,
                                        routing_sequence_no_read: ''
                                    }
                                ];
                            }
                        }
                    });
                }
            },
            itemPlanAudit(type){
                let that = this
                let arr = []
                if(type == 1){
                    for(let i = 0;i<that.selectData1.length;i++){
                        arr = [...arr,{
                            so_code:that.selectData1[i].SO_CODE
                        }]
                    }
                } else {
                    arr = [...arr,{
                        so_code:that.dataDetail.Head.so_code
                    }]

                }
                let parm = {
                    SoList: arr
                }
                that.$http.urlpost('/Pro/SO/ItemPlanAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                        if(type == 2)[
                            that.getDetail(that.code)
                        ]
                    }
                });
            },
            //批量更新点检状态
            getSpotcheckFlag(){
                let that = this
                let item = {
                    label: this.$t("getapi[12612]"),
                    name: '2_soviewspotcheckflag',
                    path: '/soviewspotcheckflag',
                    url: '/soviewspotcheckflag',
                    icon: 'video-play'
                };
                this.$router.push({path: '/soviewspotcheckflag'});
                this.$store.commit('selectMenu', item);
            },
            //批量更新责人单位
            batchDuty(){
                let that = this
                let parm = {
                }
                that.btn.duty = false
                that.$http.urlpost('/Pro/SO/ProBatchDuty', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.btn.duty = true
                });
            },
            checkDataChange() {
                let that = this;
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 181,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.MasterLists.length;i++){
                    delete datacopy.MasterLists[i]['_XID'];
                }
                for(let i = 0;i<datacopy.AssistLists.length;i++){
                    delete datacopy.AssistLists[i]['index'];
                }
                let flag = that.oldDataDetail != JSON.stringify(datacopy);
                return flag;
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-button--small,
    .el-button--small.is-round {
        padding: 0px 15px !important;
    }

 /*   .el-button--mini,

    .cell {
        line-height: 20px !important;
        padding: 0 2px !important;
    }*/

    /deep/ .green {
        background: #c8ffbb;
    }

    /deep/ .red {
        background: #ff7879;
    }

</style>
